{
  "A11Y": {
    "TRANSLATABLE_FORM_TAB_ARIA_LABEL": "Language selection tabs of the form"
  },
  "ACCESS_CONTROL": {
    "WITHOUT_RIGHT_PERMISSIONS": "You do not have sufficient rights to access this page."
  },
  "ADD_TO_CALENDAR": {
    "TITLE": "Calendar",
    "URL_WITH_EVENT": "{description} \n Join the web event: {url}"
  },
  "ANONYMOUS": "Anonymous",
  "API_SAUCE": {
    "CANCEL_ERROR": "Request has been cancelled.",
    "CLIENT_ERROR": "Oops, an unexpected error occurred.",
    "CONNECTION_ERROR": "Server not available.",
    "NETWORK_ERROR": "Network not available.",
    "SERVER_ERROR": "Oops, an unexpected error occurred.",
    "TIMEOUT_ERROR": "Server didn't respond in time."
  },
  "ARTICLE": {
    "NOT_PUBLISHED": "Unpublished",
    "PUBLICATION_ALERT": "Scheduled on {date} at {time}."
  },
  "ASSIGNMENT_CARD": {
    "AVATAR_ALT": "Owner picture",
    "TITLE": "Owner"
  },
  "ASSIGNMENT_MODAL": {
    "CHOOSE_ADMIN": "Choose an administrator",
    "TITLE": "Assign this contribution"
  },
  "ATTACHMENTS": {
    "ERROR": {
      "DELETE_FAILED": "The attachment could not be deleted.",
      "TITLE": "Error - "
    }
  },
  "ATTENDANCE": {
    "ATTEND": "Register",
    "ATTENDING": "Registered"
  },
  "AUTH": {
    "ACCEPT_SPACE_PRIVACY": "I accept the <terms>Privacy Policy</terms> of {spaceName}.",
    "ACCEPT_SPACE_TERMS": "I accept the <privacy>Terms of Use</privacy> of {spaceName}",
    "ACCEPT_SPACE_TERMS_AND_PRIVACY": "I accept the <privacy>Privacy Policy</privacy> and the <terms>Terms of Use</terms> of {spaceName}.",
    "ACCEPT_TERMS_AND_PRIVACY": "I accept the {privacy} and the {terms} of Fluicity Engage.",
    "ARIA_AUTHENTICATE_WITH": "Sign up with {provider}",
    "AUTH_LIST_TITLE": "Third-party authentication providers",
    "BACKGROUND_ALT": "Login background",
    "CONTINUE_WITHOUT_SIGNUP": "Continue without an account",
    "DELETE_TOAST": "The authentication provider was successfully deleted",
    "DESCRIPTION": "Your registration on Fluicity Engage will allow you to participate in consultations on {spaceName} and will give you access to other consultations organised on Fluicity Engage. To learn more about how we manage your personal information and to exercise your rights, please visit our <b>Privacy Policy</b>",
    "EMAIL_PLACEHOLDER": "example@email.com",
    "ENTITY_SUBSCRIPTION_FORM": {
      "CONTENT": "By joining <strong>{spaceName}</strong>, you will be informed of the latest consultations and news.<br></br><br></br>You can also help better understand if the activity is representative of the global population by sharing some information:",
      "TITLE": "Join {spaceName}!"
    },
    "ERRORS": {
      "CANNOT_DELETE_WITHOUT_PASSWORD": "Set up a password to unlink this third-party authentication service.",
      "DELETE_AUTH_FAILED": "We could not unlink this third-party authentication provider.",
      "INVALID_EMAIL": "The format of your e-mail address is invalid.",
      "NO_ASSOCIATED_ACCOUNT": "No account is associated.",
      "REQUIRED_CHECKBOX": "You must check this box.",
      "REQUIRED_EMAIL": "You must fill in an e-mail address.",
      "REQUIRED_FIRST_NAME": "You must fill in a first name.",
      "REQUIRED_LAST_NAME": "You must fill in a last name.",
      "REQUIRED_PASSWORD": "You must fill in a password.",
      "SHORT_PASSWORD": "The password must be at least {count} characters long."
    },
    "FACEBOOK_LOAD_ERROR": "It appears that an extension on your browser is preventing us from using Facebook authentication. Please disable the extension if you wish to use this feature.",
    "FIRST_NAME_PLACEHOLDER": "Example: John",
    "FORGOT_PASSWORD": "Forgotten your password?",
    "HAS_ACCOUNT": "Already have an account?",
    "HAS_SIGNED_IN": "You’re logged in to {spaceName}!",
    "LAST_NAME_PLACEHOLDER": "Example: Doe",
    "LOGIN": "Sign in",
    "NAME_PREVIEW": "Other users will see you as:",
    "NO_ACCOUNT": "No account yet?",
    "OAUTH_BUTTONS": {
      "CSAM": "Join with CSAM"
    },
    "PAGE_TITLE": "Sign in",
    "SIGNUP": "Create an account",
    "SIGNUP_EXTRAS": {
      "DESCRIPTION": "Help us to better understand whether the platform's activity is representative of the global population. This information will only be used for verification and statistical purposes related to the participation.",
      "PAGE_TITLE": "Last step!",
      "WELCOME_TOAST": "Congratulations, you are registered to {spaceName}!"
    },
    "UNLINK": "Unlink",
    "VERIFY_EMAIL": {
      "CONTENT": "Enter the verification code received at {email}.",
      "RESEND": "You haven't received an email? {link}",
      "RESEND_LINK": "Resend code",
      "RESEND_SUCCESS": "A new verification code has been sent to you.",
      "TITLE": "Verify your account",
      "VERIFY_ALERT": "Check your email address to participate in all consultations.",
      "VERIFY_SUCCESS": "Your account has been successfully verified."
    }
  },
  "BACK": "Back",
  "BUTTONS": {
    "ACCEPT": "Accept",
    "ACCESS_CONSULTATION": "Access consultation",
    "ACTIONS": "Actions",
    "ADD": "Add",
    "ADD_ATTACHMENTS": "Add files/images",
    "ADD_NEW_IDEA": "Contributions",
    "CANCEL": "Cancel",
    "CHANGE_USER": "Switch user",
    "CLEAR": "Clear",
    "CLONE": "Duplicate",
    "CLOSE": "Close",
    "COMMENT": "Comment",
    "CONFIRM": "Confirm",
    "CONTINUE": "Continue",
    "DELETE": "Delete",
    "DELETE_VOTERS": "Delete voters",
    "DRAG_DROP_ATTACHMENTS": "Drag and drop files/images here or click",
    "EXPORT": "Export",
    "EXPORT_PARTICIPANTS": "Export participants",
    "EXPORT_PROPOSALS": "Export contributions",
    "EXPORT_RESULTS": "Export results",
    "EXPORT_VOTERS": "Export voters",
    "FILTER": "Filter",
    "IGNORE": "Not now",
    "IMPORT": "Import",
    "IMPORT_VIA_EXCEL": "Import an Excel file",
    "IMPORT_VIA_FORM": "Fill out the online form",
    "IMPORT_VOTERS": "Import voters",
    "IN_PROGRESS": "In progress…",
    "JOIN": "Join",
    "LEARN_MORE": "Learn more",
    "NO": "No",
    "OPEN": "Open",
    "OPEN_IN_NEW_TAB": "Opens new tab",
    "PUBLISH": "Publish",
    "READ_MORE": "View more",
    "REJECT_ALL": "Reject all",
    "SAVE": "Save",
    "SETTINGS": "Settings",
    "SKIP": "Skip",
    "TRANSLATE_VIA_AI": "Translate via AI",
    "UPDATE": "Update",
    "UPDATE_PICTURE": "Update",
    "UPLOAD_PICTURE": "Upload picture",
    "VERIFY": "Check",
    "VERIFY_EMAIL": "Verify my email address",
    "VIEW_ANSWER": "See the answer",
    "VIEW_IDEAS": "View contributions",
    "VOTE": {
      "BUDGET": "I support",
      "NOT_SUPPORT": "I do not support",
      "SUPPORT": "I support",
      "TOAST": {
        "CANCEL": "Your vote has been cancelled",
        "SUCCESS": "Your vote has been saved"
      },
      "VOTE_AGAINST": "I vote against",
      "VOTE_FOR": "I vote for"
    },
    "WRITE": "Write"
  },
  "CHILDREN_COUNT": "{count, plural, =0 {No content} one {{count} content} other {{count} contents}}",
  "COMMENTS": {
    "AUTHOR": "Author",
    "CREATE": {
      "PRIVACY_WARNING": "This content is confidential. Only the author and the receiving organization can view it.",
      "SUBMIT": "Submit"
    },
    "CREATION": {
      "APPEND_COMMENT": {
        "IDEA": "Leave a public comment to explain the status change"
      },
      "ERROR": "Please complete these field before submitting it.",
      "PLACEHOLDER": "Your comment",
      "SUCCESS_ANOMALY": "Your anomaly has been sent.",
      "SUCCESS_DEMAND": "Your message has been sent.",
      "SUCCESS_IDEA": "Your comment has been published.",
      "VALIDATE": "Confirm"
    },
    "SHOW": {
      "BE_THE_FIRST_TO_COMMENT_CONSULTATION": "Be the first to comment!",
      "BE_THE_FIRST_TO_COMMENT_MESSAGING": "This user is waiting for your response since {date}.",
      "BE_THE_FIRST_TO_COMMENT_PARTICIPATION": "Be the first to comment!",
      "CONTRIBUTION_ENDED": "The consultation ended",
      "CONTRIBUTION_ENDED_ON": "The consultation ended on {date}",
      "CONTRIBUTION_HAS_NOT_STARTED": "The consultation begins on {date}",
      "COUNT_CONSULTATION": "{count, plural, =0 {No comments} one {{count} Comment} other {{count} Comments}}",
      "COUNT_MESSAGING": "{count, plural, =0 {No responses} one {{count} Response} other {{count} Responses}}",
      "COUNT_PARTICIPATION": "{count, plural, =0 {No comments} one {{count} Comment} other {{count} Comments}}"
    },
    "THREAD": {
      "DELETED_COMMENT": "This comment has been deleted.",
      "DISPLAY_CONVERSATION": "{count, plural, =0 {No answers} one {See {count} answer} other {See {count} answers}}",
      "REPLY": "Reply"
    },
    "TITLE": "Comments"
  },
  "CONTRAST_RATIO": {
    "DESCRIPTION": "A high contrast ratio ensures accessibility for your users. Following the international standards (WCAG) we advise you to select a color with a ratio over {ratio}:1 (level AA of the WCAG version 2.1)",
    "TEXT": {
      "BAD": "Contrast level is {value}:1 with this color. It is not enough to comply with accessibility guidelines (WCAG level AA).",
      "GOOD": "Contrast level is {value}:1 with this color. It is above threshold to comply with accessibility guidelines (WCAG level AA)"
    }
  },
  "COOKIES_SETTINGS": {
    "SSO_AUTH_MODAL": {
      "CONTENT": "{providerName} will set cookies on your machine if you wish to use this feature."
    },
    "VIDEO_PLACEHOLDER": {
      "ADS_BLOCK": "You have activated an ad blocker that prevents the display of this video. Please disable it to continue.",
      "CTA": "Allow the cookies",
      "VIMEO": "Vimeo needs to set cookies to display a video",
      "YOUTUBE": "Youtube needs to set cookies to display a video"
    }
  },
  "DASHBOARD": {
    "BUTTONS": {
      "EXPORT": {
        "CONSULTATION": "Export contributions",
        "MESSAGING": "Export",
        "PARTICIPATION": "Export"
      }
    },
    "COUNTERS": {
      "ASSIGNMENT": "{count, plural, =0 {No assignments} one {{count} Assignment} other {{count} Assignments}}",
      "COMMUNICATION": "{count, plural, =0 {No News} one {{count} News} other {{count} News}}",
      "CONSULTATION": "{count, plural, =0 {No consultations} one {{count} Consultation} other {{count} Consultations}}",
      "FOLDER": "{count, plural, =0 {No folders} one {{count} Folder} other {{count} Folders}}",
      "FOLDER_CONTENT": "{count, plural, =0 {No content} one {{count} Content} other {{count} Contents}}",
      "FORM_RESPONSES": "{count, plural, =0 {No responses} one {{count} Response} other {{count} Responses}}",
      "INVITATIONS": "{count, plural, =0 {No invitations} one {{count} invitation} other {{count} invitations}}",
      "MESSAGING": "{count, plural, =0 {No content} one {{count} Content} other {{count} Contents}}",
      "NEWSLETTERS": "{count, plural, =0 {No newsletters} one {{count} Newsletter} other {{count} Newsletters}}",
      "PARTICIPATION": "{count, plural, =0 {No contributions} one {{count} Contribution} other {{count} Contributions}}",
      "RANKING": "Contributions ranking",
      "USER": "{count, plural, =0 {No users} one {{count} User} other {{count} Users}}",
      "VOTERS": "{count, plural, =0 {No voters} one {{count} Voter} other {{count} Voters}}"
    },
    "COUNTERS_SELECTED": {
      "COMMUNICATION": "{count, plural, =0 {No news selected} one {{count} News selected} other {{count} News selected}}",
      "CONSULTATION": "{count, plural, =0 {No consultation selected} one {{count} Consultation selected} other {{count} Consultations selected}}",
      "FOLDER": "{count, plural, =0 {No folder selected} one {{count} Folder selected} other {{count} Folders selected}}",
      "FOLDER_CONTENT": "{count, plural, =0 {No content selected} one {{count} Content selected} other {{count} Contents selected}}",
      "MESSAGING": "{count, plural, =0 {No content selected} one {{count} Content selected} other {{count} Contents selected}}",
      "PARTICIPATION": "{count, plural, =0 {No selected contribution} one {{count} Selected contribution} other {{count} Selected contributions}}",
      "VOTERS": "{count, plural, =0 {No voters selected} one {{count} Voter selected} other {{count} Voters selected}}"
    },
    "EDIT": "Edit",
    "EMPTY_STATE": {
      "ASSIGNMENT": "You will find here the content that is assigned to you.",
      "COMMUNICATION": "Publish your first news",
      "CONSULTATION": "Publish your first consultation",
      "FOLDER": "Create your first folder",
      "FOLDER_CONTENT": "You will find here the folder contents",
      "FORM_RESPONSES": "You will find the responses to the questionnaire here.",
      "INVITATIONS": "You will find here the list of invitations.",
      "MESSAGING": "You will find here messages and anomalies",
      "NEWSLETTER": "Create your first newsletter",
      "PARTICIPATION": "You will find here the contributions of the consultation.",
      "SEARCH": {
        "BUTTON": "Reset the filters",
        "DESCRIPTION": "Check that you have spelled your search correctly or change the filters.",
        "TITLE": "No results"
      },
      "USER": "You will find here the list of registered users.",
      "VOTERS": "You will find here the voters of the consultation"
    },
    "FILTERS": {
      "ADDRESS_CITY": {
        "LABEL": "City",
        "PLACEHOLDER": "Filter by city"
      },
      "BLANK": "Not specified",
      "FOLDER": {
        "LABEL": "Folder",
        "PLACEHOLDER": "Filter by folder"
      },
      "NEWSLETTER_STATUS": {
        "DRAFT": "Draft",
        "SCHEDULED": "Scheduled",
        "SENT": "Sent"
      },
      "PROF_CATEGORY": {
        "LABEL": "Socio-professional category",
        "PLACEHOLDER": "Filter by socio-professional category"
      },
      "REGISTERED": {
        "LABEL": "Registered",
        "PLACEHOLDER": "Filter by registration",
        "REGISTERED": "Registered",
        "UNREGISTERED": "Not registered"
      },
      "ROLES": {
        "ADMINISTRATOR": "Administrator",
        "AUTHOR": "Author",
        "CITIZEN": "User",
        "CONTRIBUTOR": "Manager",
        "LABEL": "Role",
        "PLACEHOLDER": "Filter by role"
      },
      "SEX": {
        "LABEL": "Sex",
        "PLACEHOLDER": "Filter by sex"
      },
      "STATUS": {
        "ANSWERED": "Not selected",
        "DOING": "Under examination",
        "DONE": "Implemented",
        "DUPLICATE": "Grouped",
        "IN_PROGRESS": "Implementation in progress",
        "LABEL": "Status",
        "MESSAGING": {
          "DOING": "Under examination",
          "DONE": "Answered",
          "LABEL": "Status",
          "PLACEHOLDER": "Filter by status",
          "TODO": "Submitted"
        },
        "PLACEHOLDER": "Filter by status",
        "PLANNED": "Planned",
        "REJECTED": "Declined",
        "SELECTED": "Selected",
        "TODO": "Submitted",
        "TO_MODERATE": "To moderate",
        "VALIDATED": "Winner"
      },
      "TAG": {
        "LABEL": "Topic",
        "PLACEHOLDER": "Filter by topic"
      },
      "TYPES": {
        "ANOMALY": "Anomaly",
        "ARTICLE": "Article",
        "COLLABORATIVE_DECISION": "Collaborative decisions",
        "DEMAND": "Message",
        "EVENT": "Event",
        "FOLDER": "Folder",
        "IDEA": "Contributions",
        "IDEAS_REQUEST": "Call for contributions",
        "LABEL": "Type of content",
        "PARTICIPATORY_BUDGET": "Participatory budget",
        "PLACEHOLDER": "Filter by type",
        "STUDY": "Survey",
        "SURVEY": "Form"
      },
      "USER_TYPE": {
        "DESCRIPTION": "Online or offline",
        "LABEL": "Participation",
        "OFFLINEUSER": "Offline",
        "PLACEHOLDER": "Filter by type of participation",
        "USER": "Online"
      },
      "VISIBILITY": {
        "DRAFT": "Draft",
        "LABEL": "Visibility",
        "PLACEHOLDER": "Filter by visibility",
        "PLANNED": "Scheduled",
        "PUBLISHED": "Published"
      }
    },
    "MANAGE_FILTERS": {
      "DESCRIPTION": "The filters are saved for all authorized administrators and managers.",
      "NO_FILTERABLE_QUESTIONS": "No filters available.",
      "SECTION_TITLE_FORM": "Form information",
      "SECTION_TITLE_PARTICIPANTS": "Participant profile",
      "TITLE": "Filter"
    },
    "MENU": {
      "ASSIGNMENT": "Assignments",
      "COMMUNICATION": "News",
      "CONSULTATION": "Consultations",
      "FOLDER": "Folders",
      "GENERAL": "General",
      "MESSAGING": "Messaging",
      "NEWSLETTER": "Newsletters",
      "PARTICIPATION": "Contribution",
      "SETTINGS": "Settings",
      "SETTINGS_ACCESS": "Access",
      "SETTINGS_COMMUNICATION": "Communication",
      "SETTINGS_GENERAL": "General",
      "SETTINGS_LEGAL": "Legal texts",
      "SETTINGS_PAGES": "Pages",
      "STATS": "Overview",
      "USER": "Users"
    },
    "NEWSLETTERS": "Newsletters",
    "PARTICIPATION": "Participation",
    "POSTS_FORM": {
      "FIELDS_CONFIG": {
        "ACTIVE": "Active",
        "APPLICATION_FILE_LABEL": "Import a template of detailed application file",
        "APPLICATION_FILE_TOOLTIP": "To request additional information from users when submitting a new contribution, you can provide them with a detailed application file template.<br></br><b>Accepted formats:</b> .pdf, .doc, .docx, .txt, .odt, .rtf, .md",
        "DESCRIPTION": "The submission form corresponds to the information that the user will have to fill out to submit their contribution.",
        "REQUIRED": "Required",
        "TITLE": "Submission form"
      },
      "SETTINGS_PANEL": {
        "COMMUNICATION": {
          "TITLE": "News settings"
        },
        "CONSULTATION": {
          "TITLE": "Consultation settings"
        },
        "FOLDER": {
          "TITLE": "Folder settings"
        }
      },
      "TABS": {
        "ANALYSIS": "Analyze",
        "APPEARANCE": "General",
        "DISABLED_TOOLTIP": "Fill and save current form to access this one",
        "IMPLEMENTATION": "Results",
        "MANAGERS": "Managers",
        "PRESENTATION": "Presentation",
        "PUBLIC_FILTERS": "Public filters",
        "QUESTIONS": "Questions",
        "SECURITY": "Security",
        "SETTINGS": "Settings",
        "SUBMISSION": "Submission",
        "VOTE": "Vote"
      }
    },
    "PUBLIC_FILTERS": {
      "DESCRIPTION": "Add advanced search to your consultation to allow your users to filter contributions on your page.",
      "TITLE": "Public filters"
    },
    "SHOW": "Show",
    "TABLE": {
      "ARIA_LABELS": {
        "FIRST_PAGE": "First page",
        "LAST_PAGE": "Last page",
        "NEXT_PAGE": "Next page",
        "PREVIOUS_PAGE": "Previous page"
      },
      "BUTTONS": {
        "ACTIONS": "Actions",
        "CHANGE_STATUS": "Change status",
        "DELETE": "Delete"
      },
      "PAGINATION": "{from}-{to} of {count}",
      "TITLES": {
        "ACTIONS": "Actions",
        "ASSIGNED": "Assigned",
        "AUTHOR": "Author",
        "BIRTHDATE": "Date of birth",
        "BUDGET": "Cost",
        "COMMENTS_COUNT": "Comments",
        "COMMUNICATIONS_COUNT": "News",
        "CONSULTATION": "Consultation",
        "CONSULTATIONS_COUNT": "Consultations",
        "CONSULTATION_TITLE": "Consultation title",
        "CONTRIBUTION": "Contribution",
        "CREATED_AT": "Invitation date",
        "EMAIL": "Email",
        "FIRST_NAME": "First name",
        "FOLDER": "Folder",
        "FOLDERS_COUNT": "Folders",
        "HAS_ACCESS": "Access?",
        "ID": "ID",
        "IDEAS_COUNT": "Contributions",
        "LAST_NAME": "Last name",
        "LAST_VOTE_AT": "Vote date",
        "NEWSLETTER_CREATED_AT": "Created on",
        "NEWSLETTER_SENT_AT": "Sent on",
        "NEWSLETTER_SUBJECT": "Subject",
        "NEWSLETTER_TITLE": "Newsletter",
        "PARTICIPATION_TYPE": "Contribution",
        "PICTURE": " ",
        "PUBLICATION_DATE": "Publication",
        "RECIPIENTS": "Recipients",
        "RESPONSE_DATE": "Date",
        "ROLE": "Role",
        "SENT_AT": "Sent on",
        "SOURCE": "Participation",
        "STATE": "State",
        "STATUS": "Status",
        "SUBSCRIPTION_DATE": "Subscription date",
        "TITLE": "Title",
        "TOPIC": "Topic",
        "TYPE": "Type",
        "USER": "User",
        "VISIBILITY": "Visibility",
        "VOTES_AGAINST_COUNT": "Votes against",
        "VOTES_COUNT": "Number of votes",
        "VOTES_FOR_COUNT": "Votes for"
      }
    }
  },
  "DATE": {
    "INPUT_FORMAT": "YYYY/MM/DD"
  },
  "DATE_TIME": {
    "DAYS_LEFT": "{count, plural, =0 {Last day} one {{count} day left} other {{count} days left}}",
    "INVALID_LABEL": "Invalid",
    "IN_N_DAYS": "Starts {count}",
    "LABEL": {
      "DEFAULT": "Select a date",
      "SCHEDULE_LABEL": "Schedule on",
      "SCHEDULE_TITLE": "Schedule the publication"
    }
  },
  "DISCUSSION": {
    "EMAIL": {
      "CONTENT": {
        "LABEL": "Email Content",
        "PLACEHOLDER": "Hello, ..."
      },
      "DELETED_USER_WARNING": "This user has requested to delete their account. You cannot contact them.",
      "SEND": "Send",
      "SUBJECT": {
        "LABEL": "Email Subject",
        "PLACEHOLDER": "Request for additional information about..."
      }
    },
    "SHOW": {
      "COMMENTS_COUNT": "{count, plural, =0 {No private notes} one {{count} Private note} other {{count} Private notes}}",
      "COMMENT_PLACEHOLDER": {
        "PRIVATE": "Write a private note",
        "PUBLIC": "Your comment"
      },
      "INFO": "Be careful not to write comments containing data considered sensitive.",
      "INFO_TOOLTIP": "Racial or ethnic origin, political, philosophical or religious opinions, trade union membership, health data, sexual preference, criminal record,…",
      "NO_COMMENTS": "Be the first to write a private note"
    }
  },
  "DUPLICATED_POSTS": {
    "TITLE": "{count, plural, =0 {# similar contributions grouped with this one} one {{count} similar contribution grouped with this one} other {{count} similar contributions grouped with this one}}"
  },
  "ERROR_PAGES": {
    "BACK_TO_SPACE": "Return to home page",
    "CTA_NO_SPACE": "Browse available spaces",
    "FORMER_CLIENT_TOAST": "The space you’re trying to access does not exist or has been closed.",
    "NOT_FOUND": {
      "DESCRIPTION": "It seems that we have taken you down the wrong path. Let's start afresh?",
      "TITLE": "Sorry, we could not find the page you were looking for."
    },
    "OFFLINE": {
      "DESCRIPTION": "It seems that you are offline. Let's refresh?",
      "TITLE": "Sorry, we could not find the page you were looking for."
    },
    "RELOAD": "Reload",
    "SERVER_ERROR": {
      "DESCRIPTION": "Rest assured that our developers are doing everything possible to fix it. We should be back shortly.",
      "TITLE": "Oops, an unexpected error occurred."
    }
  },
  "FOOTER": {
    "ACCESSIBILITY": "Accessibility",
    "ETHICAL_POLICY": "Ethics Policy",
    "HELP": "Help",
    "LEGAL_NOTICE": "Legal Notice",
    "PRIVACY_POLICY": "Privacy Policy",
    "TERMS_OF_USE": "Terms of use"
  },
  "FORM": {
    "ERRORS": {
      "FILL_CORRECTLY": "You must fill in the fields correctly.",
      "REQUIRED": "You must fill in this field."
    },
    "SELECT_EMPTY_LABEL": "Unspecified",
    "TOASTS": {
      "DELETED_SUCCESSFULLY": "Successfully deleted",
      "UPDATED_SUCCESSFULLY": "Updated successfully"
    }
  },
  "FORM_RESPONSES": {
    "CREATED_AT": "Answered on <b>{date}</b> at <b>{time}</b>",
    "SHOW_RESPONSE": "Show my response",
    "SUBMISSION_NOT_ONGOING": "The consultation is closed, you can no longer respond or modify your response.",
    "UPDATE_RESPONSE": "Edit my response"
  },
  "GENERIC_CONFIRM_DELETE": {
    "CONTENT": "Are you sure you want to delete this item?",
    "CTA": "Yes, delete",
    "TITLE": "Delete"
  },
  "HOME": {
    "PAGE_TITLE": "Welcome to Fluicity Engage",
    "SEARCH_PLACEHOLDER": "Type the name of the space",
    "SUBTITLE": "Find the right space to start contributing"
  },
  "IMAGE": {
    "FAILED_TO_LOAD": "Failed to load image",
    "LOADING": "Loading the image"
  },
  "IMPORT": {
    "CONTRIBUTIONS": {
      "HEADLINE": {
        "DESCRIPTION": "To add multiple contributions received outside the platform, {link} without modifying their format.<br></br>If you have not collected certain information, please do not delete the columns and leave them empty.<br></br>If your contributions are in several languages, please translate them all into {defaultLang} before importing.",
        "LINK": "complete the template",
        "TITLE": "Import contributions"
      },
      "STATUS": {
        "DESCRIPTION": "Indicate the status of contributions during import",
        "TITLE": "Select the status"
      }
    },
    "ERROR": {
      "DESCRIPTION": "Unable to import your file. Please make sure your file complies with the template.",
      "EXPLANATION": "Ensure that no column has been deleted and that the responses adhere to the requested format.",
      "ROWS_MULTIPLE": "Unable to import your file. Errors were identified on lines {rows}.",
      "ROWS_SINGLE": "Unable to import your file. An error was identified on line {rows}.",
      "ROWS_WITH_MORE": "Unable to import your file. Errors were identified on lines {rows} and {moreCount} others."
    },
    "FORM": {
      "CTA": "Import",
      "UPLOAD_DATE": "{size} - Last updated on {date}",
      "UPLOAD_TITLE": "Drag the file or click"
    },
    "FORM_RESPONSES": {
      "HEADLINE": {
        "DESCRIPTION": "To add multiple responses received outside the platform, {link} without modifying their format.<br></br>If you haven't collected certain information, please do not delete the columns and leave them empty.<br></br>If your responses are in multiple languages, please translate them all into {defaultLang} before importing.",
        "LINK": "fill in the template",
        "TITLE": "Import responses"
      }
    },
    "PREVIEW": {
      "DESCRIPTION": "Make sure the information in your import matches the columns in the template.<br></br>If the information does not match, you must modify your file and then import your updated file.",
      "TITLE": "Check the data"
    },
    "PROGRESS": "Import in progress...",
    "VOTERS": {
      "HEADLINE": {
        "DESCRIPTION": "To add votes received outside the platform, {link} without modifying the format. If you have not collected certain information, please <b>do not delete the columns</b> and leave them empty.",
        "LINK": "fill in the template",
        "TITLE": "Import Votes"
      }
    }
  },
  "JOIN": "Join",
  "JOINED_SPACE": "Welcome to {space}!",
  "KEEP_ME_ALIVE": {
    "ALERT": {
      "CONTENT": "We will keep you posted if consultations for you are released in the future. You can also find other existing spaces by using the search bar below and logging in with your current account.",
      "CONTENT_NOT_FOUND": "In order to participate in a consultation again, you will need to recreate an account.",
      "TITLE": "Thank you for choosing to keep your account active.",
      "TITLE_NOT_FOUND": "Your account no longer exists or has already been anonymized!"
    }
  },
  "LOADING_MORE": "Loading more…",
  "LOAD_MORE": "Load more",
  "MENU_ITEMS": {
    "DESCRIPTION": "Customize the tabs that appear in your navigation bar.",
    "FORM": {
      "ADD_ITEM": "Add a tab",
      "ADD_SUBITEM": "Add a sub-tab",
      "INPUTS": {
        "LABEL": {
          "LABEL": "Label",
          "PLACEHOLDER": "Enter the label for your tab"
        },
        "LINK": {
          "LABEL": "External link",
          "PLACEHOLDER": "https://site.com"
        },
        "PAGE": {
          "LABEL": "Default page",
          "PLACEHOLDER": "Select a page"
        },
        "POST": {
          "LABEL": "Content",
          "NO_OPTIONS": "No content found",
          "PLACEHOLDER": "Search for content"
        },
        "POST_CATEGORY": {
          "COMMUNICATION": "News",
          "CONSULTATION": "Consultations",
          "FOLDER": "Folder",
          "LABEL": "Content type",
          "PLACEHOLDER": "Select a content type"
        },
        "TYPE": {
          "LABEL": "Type",
          "PLACEHOLDER": "Select a type"
        }
      }
    },
    "GROUP": "Dropdown menu",
    "LINK": "External link",
    "NEW_GROUP": "NEW DROPDOWN MENU",
    "NEW_ITEM": "New item",
    "PAGE": "Default page",
    "PAGE_ABOUT": "About",
    "PAGE_CONSULTATIONS": "Consultations",
    "PAGE_NEWS": "News",
    "PAGE_SEARCH": "Search",
    "POST": "Content",
    "TITLE": "Your navigation bar"
  },
  "MESSAGING_BLOC": {
    "ANOMALY": {
      "REPORT_CTA": "Report an anomaly"
    },
    "DEMAND": {
      "REPORT_CTA": "Send a message"
    }
  },
  "META_TAGS": {
    "DEFAULT_DESCRIPTION": "Fluicity Engage is a citizen engagement solution, which allows collective decision-making around topics of general interest.",
    "PAGES_TITLES": {
      "ABOUT": "About | {spaceName}",
      "CONSULTATIONS": "Consultations | {spaceName}",
      "CONTRIBUTIONS": {
        "MESSAGING": "My messages and anomalies | {spaceName}",
        "PROPOSALS": "My contributions | {spaceName}"
      },
      "DASHBOARD": "Dashboard | {spaceName}",
      "LEGAL_NOTICE": "Legal Notice | {spaceName}",
      "NEWS": "News | {spaceName}",
      "PRIVACY_POLICY": "Privacy Policy | {spaceName}",
      "SEARCH": "Search | {spaceName}",
      "SETTINGS": "My account | {spaceName}",
      "TERMS_OF_USE": "Terms of Use | {spaceName}"
    },
    "STATUS_TO_SHARE": {
      "ARTICLE": "{cityName}: discover this article on Fluicity Engage!",
      "EVENT": "{cityName}: participate in this event!",
      "FOLDER": "{title} {url}",
      "IDEA": "Support this contribution: {title} {url}"
    },
    "TITLE_TO_SHARE": {
      "FOLDER": "{title}",
      "IDEA": "Support this contribution: {title}"
    }
  },
  "MODERATION": {
    "MODAL": {
      "DESCRIPTION": "You can modify your contribution or submit it as is. The services will assess whether your contribution can be published or not.",
      "REASON": "Reason:",
      "SUBMIT": "Submit",
      "TITLE": "Your contribution has been identified as suspicious."
    }
  },
  "MOMENT": {
    "DATE": {
      "DEFAULT": "YYYY-MM-DD",
      "PLACEHOLDER": "YYYY-MM-DD"
    }
  },
  "NAVBAR": {
    "DASHBOARD": "Dashboard",
    "MY_ACCOUNT": "My account",
    "MY_PROFILE": "My profile"
  },
  "NEWSLETTERS": {
    "ALREADY_SENT": "This newsletter has already been sent",
    "CREATED_AT": "Created on <b>{date}</b> at <b>{time}</b>",
    "DRAFT": "Draft",
    "FORM": {
      "CLEAR_SCHEDULING": "Clear scheduling",
      "CONTENT": {
        "LABEL": "Email body",
        "PLACEHOLDER": "Write your email body here"
      },
      "RECIPIENTS": {
        "ALL": "All users",
        "LABEL": "Recipients",
        "PLACEHOLDER": "Select the recipients of the email"
      },
      "SAVE_SUCCESS": "Your newsletter has been registered successfully",
      "SCHEDULE": "Schedule",
      "SCHEDULED_AT": "Delivery date",
      "SEND": "Send",
      "SEND_SUCCESS": "Your newsletter has been sent successfully",
      "SEND_TEST": "Send the test",
      "SUBJECT": {
        "LABEL": "Email subject",
        "PLACEHOLDER": "Write a headline that engages users."
      },
      "TEST_EMAIL": {
        "LABEL": "Test email addresses",
        "PLACEHOLDER": "Enter the test email addresses separated by a comma"
      },
      "TEST_SUCCESS": "Your test newsletter has been sent successfully"
    },
    "IMMEDIATELY": "Immediately",
    "NEW_NEWSLETTER": "Create a newsletter",
    "SCHEDULED": "Scheduled",
    "SENT": "Sent",
    "SENT_AT": "Sent on <b>{date}</b> at <b>{time}</b>",
    "UPDATE_NEWSLETTER": "Update the newsletter",
    "USERS_FILTER_COUNT": "{count, plural, =0 {No recipients has been found for this selection} one {Your newsletter will be sent to 1 person} other {Your newsletter will be sent to {count} people}}"
  },
  "NEXT": "Next",
  "NONE": "None",
  "NOTIFICATIONS_SETTINGS": {
    "ADMINISTRATOR": {
      "DAILY_DIGEST": {
        "DESCRIPTION": "Consultations:<br />• New contributions<br />• New survey responses<br />• When a citizen responds to one of my comments<br />• When a phase or consultation is ending soon<br /><br />Messaging:<br />• New messages<br />• New anomalies<br />• When a citizen responds to one of my comments",
        "SUBTITLE": " (daily)",
        "TITLE": "Latest activities"
      },
      "SUBSCRIBED_ACTIVITIES_NOTIFICATIONS": {
        "DESCRIPTION": "• Modification of a contribution by its author<br />• Moderation of content by the Fluicity Engage team",
        "TITLE": "Other"
      }
    },
    "CITIZEN": {
      "CONSULTATIONS_NOTIFICATIONS": {
        "DESCRIPTION": "• New consultation<br />• Start of a submission, voting or results phase",
        "TITLE": "Consultations"
      },
      "DAILY_DIGEST": {
        "DESCRIPTION": "• Comment or vote on my contribution<br />• Reply to my comment<br />• Change status of my contribution",
        "SUBTITLE": " (daily)",
        "TITLE": "Your latest activities"
      },
      "NEWSLETTER_NOTIFICATIONS": {
        "DESCRIPTION": "• Newsletters concerning the activity of the platform",
        "TITLE": "Newsletters"
      },
      "SUBSCRIBED_ACTIVITIES_NOTIFICATIONS": {
        "DESCRIPTION": "• Deletion of a contribution you have commented on<br />• Moderation of a content you have commented on",
        "TITLE": "Other"
      },
      "WEEKLY_DIGEST": {
        "DESCRIPTION": "• New articles<br />• New events<br />• Featured contributions",
        "SUBTITLE": " (weekly)",
        "TITLE": "Currently on the space"
      }
    },
    "INFO_BOX_TEXT": "Select here the email notifications that you want to receive from the platform."
  },
  "NPS_FORM": {
    "CONTENT_FIELD": "Why?",
    "EXTREMELY_LIKELY": "Extremely likely",
    "NOT_LIKELY": "Not likely",
    "TITLE": "Tell us what you think about Fluicity Engage",
    "VALUE_QUESTION": "How likely are you to recommend Fluicity Engage to a peer?"
  },
  "OFFLINE": "Offline",
  "ONLINE": "Online",
  "OR": "OR",
  "ORIGINAL_POST": {
    "NO_OPTIONS": "No contribution can be selected",
    "TITLE": "This contribution has been merged with the following similar contribution."
  },
  "PAGE_OF": "Page {current} of {total}",
  "PASSWORD_RESET": {
    "ACTION": "update",
    "ARIA_LABEL": "Toggle password visibility",
    "PAGE_TITLE": "Create a new password",
    "TITLE": "Create a new password",
    "TOAST": "The new password has been saved."
  },
  "PASSWORD_RESET_REQUEST": {
    "HOMEPAGE_LINK": "Return to the homepage",
    "LINK_SENT": "If an account is associated with the email <strong>{email}</strong>, you will receive a reset link. <br></br><br></br>If you don't see an email, check your spam mail.",
    "PAGE_TITLE": "Reset your password",
    "RESET": "Reset",
    "SUB_TITLE": "Forgot your password? It happens to everyone! We will send you an email with a link to reset it.",
    "TITLE": "Reset your password"
  },
  "PICTURE_PICKER": {
    "COVER": "Choose an image to illustrate your publication"
  },
  "POSTS": {
    "AUDITS": {
      "CREATE": "Created {date}",
      "MODAL": {
        "AFTER": "After change",
        "BEFORE": "Before change",
        "TITLE": "History"
      },
      "NO_AUDITS": "This contribution has not yet been updated.",
      "UPDATE": "Updated {date}"
    },
    "AUTHOR": "Author",
    "BUDGET": {
      "ALERT": "You must <b>enter the cost</b> of the contribution before setting it as \"Selected\".",
      "BUDGET_VALUE": "This contribution costs <b>{budget}</b>",
      "MODAL_LABEL": "Cost of the contribution",
      "MODAL_TITLE": "Fill in the cost",
      "NOT_ENOUGH_BUDGET": "The remaining budget is insufficient.",
      "NOT_SELECTED": "This contribution was not selected for the voting phase",
      "REMAINING_BUDGET": "You still have <strong>{remaining}</strong> to spend"
    },
    "CARD": {
      "CONTRIBUTE": "Contribute",
      "PARTICIPATE": "Participate",
      "READ_MORE": "Read more",
      "VOTE": "Vote"
    },
    "CAROUSEL": {
      "PROGRESS": {
        "TOOLTIP_1": "{progress, plural, =0 {No votes} one {{progress} vote} other {{progress} votes}}",
        "TOOLTIP_2": "out of {total, plural, =0 {{total} contribution} one {{total} contribution} other {{total} contributions}}"
      },
      "PROMPT": {
        "PROPOSAL_CARD": {
          "CTA": "Contribution",
          "TEXT_1": "Or if you want to go further",
          "TEXT_2": "let’s make a contribution?"
        },
        "VOTE_CARD": {
          "CTA": "Vote",
          "TEXT_1": "You have already browsed some contributions {emoji}",
          "TEXT_2": "do you want to keep on?",
          "TEXT_3": "or access the full list"
        }
      }
    },
    "CLONE": {
      "ACTION": "Duplicate",
      "CANCEL": "No",
      "CONFIRM": "Yes, duplicate",
      "CONTENT_CLONED": "This content has been successfully duplicated.",
      "DESCRIPTION": "Do you really want to duplicate this content?",
      "SUCCESS": "This content has been deleted."
    },
    "COMMENTS_COUNT": "{count, plural, =0 {Comments} one {response} other {Comments}}",
    "CONSULTATIONS": {
      "BE_THE_FIRST_TO_PARTICIPATE": "Be the first to participate!",
      "CONSULTATIONS_COUNT": "{count, plural, =0 {consultations} one {{count} consultation} other {{count} consultations}}",
      "ENDED_AT": "Consultation ended on {date}",
      "FEED_TITLE": {
        "IDEAS_COUNT": "{itemCount, plural, =0 {No contributions} one {# contribution} other {# contributions} }",
        "LOCATED_IDEAS_COUNT": "{itemCount, plural, =0 {No localized contributions} one {1 localized contribution} other {# localized contributions}}"
      },
      "MAP_TOOLTIP": "Non-geolocated contributions do not appear on the map. A contribution can have multiple locations.",
      "NEWS_COUNT": "{count} News",
      "ONGOING_TEXT": "Visit here to participate.",
      "PARTICIPATE_OFF": "Come back later to be able to contribute",
      "POST_SIDE_PRIMARY_ACTION": {
        "IMPLEMENTATION": "Discover the results",
        "PARTICIPATE": "Participate in the consultation"
      },
      "SEE_OWN_VOTES": "Show only my votes",
      "STARTS_AT": "Consultation starts on the {date}",
      "STEP_ENDED_AT": "The \"{step}\" phase ended on {date}",
      "STEP_STARTS_AT": "Save the date {date} to discover the phase \"{step}\""
    },
    "CONTENT_DELETED_SUCCESSFULLY": "the content has been deleted",
    "CREATE_MENU": {
      "ACTIONS": "Actions",
      "ADDED_TO_FOLDER_TOAST": "Content added to the folder.",
      "ADD_TO_FOLDER": "Add to a folder",
      "ARTICLE": {
        "DESCRIPTION": "Inform your users"
      },
      "ASSIGN": "Assign",
      "BUTTON": "Create",
      "COLLABORATIVE_DECISION": {
        "DESCRIPTION": "Implement co-constructed contributions with users"
      },
      "CONTACT_AUTHOR": "Contact author",
      "DIALOG_TITLE": {
        "COMMUNICATION": "Create a news",
        "CONSULTATION": "Create a consulation"
      },
      "EDIT": "Edit",
      "EVENT": {
        "DESCRIPTION": "Invite your users to a meeting"
      },
      "FOLDER": {
        "DESCRIPTION": "Create a page to centralize content"
      },
      "IDEAS_REQUEST": {
        "DESCRIPTION": "Gather contributions about your key topics"
      },
      "MERGE": "Group the contribution",
      "PARTICIPATORY_BUDGET": {
        "DESCRIPTION": "Allocate a budget to co-created contributions with users"
      },
      "PIN": "Pin",
      "REMOVED_FROM_FOLDER_TOAST": "Content removed from the folder.",
      "REPORT": "Report",
      "STEPS_COUNT": "{count, plural, one {# step} other {# steps}}",
      "STUDY": {
        "DESCRIPTION": "Embed a survey created outside the platform",
        "TITLE": "Survey - Integration"
      },
      "SURVEY": {
        "DESCRIPTION": "Survey users on a specific topic and gather nuanced information"
      },
      "UNPIN": "Unpin",
      "UNPUBLISH": "Unpublish",
      "UPDATE_BUDGET": "Fill in the cost",
      "UPDATE_STATUS": "Change status",
      "VIEW": "See the publication",
      "VIEW_IN_DASHBOARD": "Dashboard",
      "VIEW_POST": "View post"
    },
    "DELETE": {
      "ACTION": "Delete",
      "CANCEL": "No",
      "CONFIRM": "Delete",
      "CONTENT_DELETED": "This content has been deleted.",
      "DESCRIPTION": "Are you sure you want to delete this content?",
      "PLACEHOLDER": "Add a comment to detail your deletion.",
      "REASON": "Comment",
      "SELECT_REASON": "Indicate why you are deleting this content:",
      "SUCCESS": "The content was deleted."
    },
    "DETAILS": {
      "AUTHORED_BY": "Carried by {name}",
      "DESCRIPTION_TITLE": "Description",
      "EVENT": {
        "ACCESS_THE_EVENT": "Access the event",
        "EVENT_URL": "Online meeting",
        "STATE": {
          "FUTURE": "The event starts on <b>{date}</b> at <b>{time}</b>.",
          "ONGOING": "Ongoing event",
          "PAST": "The event has ended"
        }
      },
      "MORE_TAGS": "{count, plural, one {and another topic} other {and {count} other topics}}",
      "STUDY": {
        "JOIN_BUTTON": "Join",
        "JOIN_DESCRIPTION": "Login or register to access the survey!",
        "PARTICIPATE": "Participate",
        "POST_SIDE_DESCRIPTION": {
          "COMING": "The survey begins on {date}.",
          "ENDED": "The survey ended on {date}.",
          "ONGOING_ANSWERED": "Thank you for your participation, it has been taken into account."
        },
        "SEE_RESULTS": "See the results"
      },
      "UPDATE_MY_IDEA": "Edit"
    },
    "EXPORT": {
      "BUTTON": "Export",
      "IDEAS": "All contributions",
      "MESSAGES": "All the messages"
    },
    "FILTER_BY_IS_PINNED": "Pinned",
    "FILTER_BY_PUBLISHED": "Published",
    "FILTER_BY_STATUS": "Status",
    "FILTER_BY_TAGS": "Topic",
    "FILTER_BY_TYPE": "Content type",
    "FILTER_IS_PINNED_TRUE": "Yes",
    "FILTER_PUBLISHED_FALSE": "Not published",
    "FILTER_PUBLISHED_TRUE": "Published",
    "FILTER_STATUS_ANSWERED": "Not selected",
    "FILTER_STATUS_DOING": "Under examination",
    "FILTER_STATUS_DONE": "Implemented",
    "FILTER_STATUS_IN_PROGRESS": "Implementation in progress",
    "FILTER_STATUS_SELECTED": "Selected",
    "FILTER_STATUS_TODO": "Submitted",
    "FILTER_STATUS_VALIDATED": "Winner",
    "FILTER_TYPE_ANOMALY": "Anomaly",
    "FILTER_TYPE_ARTICLE": "Article",
    "FILTER_TYPE_COLLABORATIVE_DECISION": "Collaborative decisions",
    "FILTER_TYPE_DEMAND": "Message",
    "FILTER_TYPE_EVENT": "Event",
    "FILTER_TYPE_FOLDER": "Folder",
    "FILTER_TYPE_IDEA": "Contribution",
    "FILTER_TYPE_IDEAS_REQUEST": "Call for contributions",
    "FILTER_TYPE_PARTICIPATORY_BUDGET": "Participatory budget",
    "FILTER_TYPE_STUDY": "Survey",
    "FOLDER": {
      "IS_OPEN_TO_PROPOSITIONS": "Open to new contributions"
    },
    "FORM": {
      "ADDRESS": {
        "LABEL": "Location",
        "PLACEHOLDER": "Add a place"
      },
      "CATEGORIES": {
        "LABEL": "Topics",
        "PLACEHOLDER": "Select the topics of the consultation",
        "SELECT_ALL": "Select all"
      },
      "CATEGORY": {
        "LABEL": "Topic",
        "PLACEHOLDER": "Select topic"
      },
      "CONTENT": "Description",
      "PICTURE": {
        "BUTTON": {
          "ADD_FILE_OR_PICTURE": "Add a file/image",
          "ADD_PICTURE": "Add a picture",
          "DELETE_PICTURE": "Delete"
        },
        "ERRORS": {
          "FILE_SIZE": "File size should not exceed {fileSize}MB.",
          "FILE_TYPE": "The images must be in the {fileTypes} format."
        },
        "TOOLTIP": "<b>Recommended size:</b> {width} (width) by {height} pixels (height) <br></br> <b>File types:</b> .jpg, .jpeg, .png"
      },
      "PIN": "This content has been pinned.",
      "TITLE": "Title",
      "UNPIN": "This content is no longer pinned."
    },
    "HOW_IT_WORKS": {
      "TITLE": "How does it work?"
    },
    "INDICATORS": {
      "ATTENDEES": "Attendees",
      "COMMENTS": "Comments",
      "COMMUNICATIONS": "News",
      "CONSULTATIONS": "Consultations",
      "IDEAS": "Contributions",
      "VOTES": "Votes"
    },
    "INTERACTIONS_BOX": {
      "CONTINUE_CONVERSATION": "Continue the conversation",
      "GIVE_YOUR_OPINION": "Give your opinion"
    },
    "PREVIEW": "View in website",
    "PUBLIC_STUDY": "Public study",
    "PUBLISHED": "Published",
    "PUBLISHED_AT": "Published on {date}",
    "PUBLISH_CANCELED": "The publication of this content has been cancelled",
    "PUBLISH_EDIT": "Edit the planning",
    "PUBLISH_NOW": "Publish now",
    "PUBLISH_NOW_TOASTER": "Your content is now visible to users",
    "PUBLISH_SCHEDULED": "Schedule the publication",
    "REPORT": {
      "ACTION": "Report",
      "CODE_OF_ETHICS": "Code of Ethics",
      "CONFIRM": "Submit",
      "EMPTY_ERROR": "You must fill in the fields correctly.",
      "FLUICITY_TERMS_PART_A": "Learn more about the",
      "FLUICITY_TERMS_PART_B": "and",
      "FLUICITY_TERMS_PART_C": "of Fluicity Engage.",
      "PLACEHOLDER": "Add a comment to detail your report.",
      "SELECT_REASON": "Indicate why you are reporting this content:",
      "SUCCESS": "Thank you for reporting it. It enables us to ensure the quality of content on Fluicity Engage.",
      "TERMS_OF_USE": " Terms of Use"
    },
    "RESPONSES_COUNT": "{count, plural, =0 {Response} one {Response} other {Responses}}",
    "SAVE": "Save",
    "SAVE_THE_DRAFT": "Save the draft",
    "SCHEDULE": "Schedule",
    "SCHEDULED": "Scheduled",
    "SCHEDULED_AT": "Scheduled on {date}",
    "SCHEDULED_AT_TOASTER": "The publication of this content is scheduled for {date}",
    "SEE": {
      "COLLABORATIVE_DECISION": "See the collaborative decisions",
      "FOLDER": "See the folder",
      "IDEA": "View the contribution",
      "IDEAS_REQUEST": "See the call for contributions",
      "PARTICIPATORY_BUDGET": "See the participatory budget"
    },
    "SHOW": {
      "FROM_DATE_TO_DATE_WITH_TIME": "From <strong>{startAtDate} at {startAtHour}</strong> to <strong>{endAtDate} at {endAtHour}</strong>",
      "QR_CODE": {
        "BLACK_AND_WHITE": "Black and white",
        "DOWNLOAD": "Download",
        "GENERATE": "Generate QR code",
        "TITLE": "QR code"
      },
      "SHARE_IT": "Share"
    },
    "SORT": {
      "BUTTON": "Sort",
      "POPULAR": "Popular",
      "RECENT": "Recent"
    },
    "STATS": {
      "TITLE_PARTICIPATION": "Synthesis of the participation"
    },
    "STATUS": {
      "FORM_TITLE": "Change status",
      "MODAL": {
        "TITLE": "Contribution progress"
      },
      "ORIGINAL_POST": {
        "LABEL": "Title of the original contribution that will be preserved.",
        "TITLE": "Enter the original post to which this contribution is linked:"
      },
      "POPOVER": {
        "BUTTON": "Read more about it"
      },
      "SUBMIT": "Update",
      "TITLE": "Status",
      "UPDATED_SUCCESSFULLY": "Status has been updated successfully."
    },
    "STEPS": {
      "STATES": {
        "AVAILABLE": "Available",
        "COMING": "Upcoming",
        "ENDED": "Completed",
        "ENDLESS": "Continuous",
        "ONGOING": "In progress"
      },
      "TABS": {
        "LABEL": "Publication phase selection tabs"
      }
    },
    "SUMMARY": {
      "TITLE": "Summary of the contribution",
      "TOOLTIP": "This summary was generated with the help of artificial intelligence to make it easier for you to read the contribution."
    },
    "TAGS": {
      "PERIOD": "From <strong>{startAtDate} at {startAtHour}</strong> to <strong>{endAtDate} at {endAtHour}</strong>",
      "PERIOD_SAME_DAY": "The <strong>{startAtDate}</strong> from <strong>{startAtHour}</strong> to <strong>{endAtHour}</strong>",
      "PERIOD_SHORT": "From <strong>{startAtDate}</strong> to <strong>{endAtDate}</strong>"
    },
    "TYPES": {
      "ANOMALY": "Anomaly",
      "ARTICLE": "Article",
      "COLLABORATIVE_DECISION": "Collaborative decisions",
      "DEMAND": "Message",
      "EVENT": "Event",
      "FOLDER": "Folder",
      "IDEA": "Contribution",
      "IDEAS_REQUEST": "Call for contributions",
      "PARTICIPATORY_BUDGET": "Participatory budget",
      "STUDY": "Survey",
      "SURVEY": "Form"
    },
    "UPDATED": "The post has been updated successfully."
  },
  "POST_FORM": {
    "ACTION_SAVE": "Save",
    "ADMIN_UPDATE_ALERT": "When you modify a contribution, we automatically send a notification by email to its author. To ensure that the author agrees with your modification, we advise you to contact them directly beforehand.",
    "APPLICATION_FILE": "Import your detailed application file",
    "APPLICATION_FILE_BUTTON": "Upload file",
    "APPLICATION_FILE_TOOLTIP": "To submit your contribution, you must provide a detailed application file. To do this, fill out the provided template and submit it below.<br></br><br></br>Contrary to the information provided in the rest of the form (title, description, topic, etc.) which will be public, the content of the file will only be accessible by platform administrators.<br></br><br></br><b>Accepted formats:</b> .pdf, .doc, .docx, .txt, .odt, .rtf, .md",
    "ATTACHMENTS": {
      "DESCRIPTION": {
        "COMMUNICATION": "Share additional documents such as images or a video with your news.",
        "CONSULTATION": "Share additional documents such as your regulations, images, or a video with your consultation.",
        "FOLDER": "Share additional documents such as images or a video to your folder."
      },
      "TITLE": "Attachments"
    },
    "ATTACHMENTS_FILES": "Files",
    "ATTACHMENTS_IMAGES": "Images",
    "ATTACHMENTS_TITLE": "Documents",
    "AUTHORED_BY": "Who is the author?",
    "AUTHORED_BY_A_THIRD_PARTY": "A third party",
    "AUTHORED_BY_A_THIRD_PARTY_PLACEHOLDER": "A person outside the platform",
    "AUTHORED_BY_CUSTOM": "Customized",
    "AUTHORED_BY_CUSTOM_PLACEHOLDER": "Association, group of citizens, assembly...",
    "AUTHORED_BY_FIRST_NAME": "Authors’ first name",
    "AUTHORED_BY_FIRST_NAME_PLACEHOLDER": "Example: John",
    "AUTHORED_BY_LAST_NAME": "Authors’ last name",
    "AUTHORED_BY_LAST_NAME_PLACEHOLDER": "Example: Doe",
    "AUTHORED_BY_MYSELF": "Me",
    "AUTHORED_BY_MY_SPACE": "My organisation",
    "BUDGET": "Estimated budget",
    "BUDGET_PLACEHOLDER": "Indicate the budget",
    "CHOOSE_A_FOLDER": "Choose a folder",
    "CONTENT": "Description",
    "CONTRIBUTION_KIND": {
      "CUSTOM_LABEL": "Contribution type",
      "CUSTOM_PLACEHOLDER": "Specify the type of contributions you want to gather.",
      "DESCRIPTION": "Customize the button label (CTA) to submit contributions.",
      "OPTIONS": {
        "CONTRIBUTION": "Contribution",
        "OTHER": "Other",
        "PROPOSAL": "Proposal",
        "QUESTION": "Question",
        "REPORT": "Report"
      },
      "PREVIEW": "Preview:",
      "TITLE": "Type of contribution"
    },
    "DEFAULT_PROPOSAL_VIEW": {
      "OPTIONS": {
        "CAROUSEL": {
          "DESCRIPTION": "To encourage reactions (vote for or against)",
          "NAME": "Carousel"
        },
        "LIST": {
          "DESCRIPTION": "For a compact display of all contributions",
          "NAME": "List"
        },
        "MAP": {
          "DESCRIPTION": "For a geographical visualization of contributions",
          "NAME": "Map"
        }
      },
      "SUBTITLE": "Customize the page of your consultation by choosing the default view of contributions. In any case, users will be able to choose a different view.",
      "TITLE": "Display of contributions"
    },
    "DESCRIPTION": "Description",
    "DESCRIPTION_SECTION": {
      "DESCRIPTION": {
        "COMMUNICATION": "This section allows you to explain to users the context and stakes of your news.",
        "CONSULTATION": "This section allows you to explain to users the context and stakes of your consultation.",
        "FOLDER": "This section allows you to explain to users the context and stakes of your file."
      },
      "TITLE": "Description of the approach"
    },
    "DISPLAY_OPTIONS": {
      "CHILDREN_LIST_PICTURES": {
        "LABEL": "Display contribution images in the list.",
        "TITLE": "Image"
      },
      "COMMENTS_ENABLED": {
        "LABEL": "Enable comments under your study"
      },
      "GEOJSON": {
        "DESCRIPTION": "Customize the map with geographical areas and points of interest on {link} then paste the code below.",
        "TITLE": "Customize the map"
      }
    },
    "EDIT": {
      "TITLE": {
        "ANOMALY": "Edit the anomaly",
        "COMMUNICATION": "Edit the news",
        "CONSULTATION": "Edit the consultation",
        "DEMAND": "Edit the message",
        "FOLDER": "Edit the folder",
        "IDEA": "Edit the contribution"
      }
    },
    "EDITORS_FORM": {
      "DESCRIPTION": "To give a user access, they must be a <i>Manager</i> of the space. Only an <i>Administrator</i> can assign this role.",
      "SUBTITLE": "The list of users who have access to manage that consultation.",
      "TITLE": "Managers"
    },
    "END_AT": "End date and time",
    "ERRORS": {
      "FILL_FIELDS": "You must correctly fill in the fields.",
      "LOCATION_NOT_IN_THE_LIST": "You must select an address from the list."
    },
    "EVENT_URL_LABEL": "Web event",
    "EVENT_URL_PLACEHOLDER": "Provide the URL of a Zoom, Jitsi, Teams, Meet, etc.",
    "FORM_BUILDER": {
      "ACCEPTED_ANSWERS": "Allowed response(s)",
      "ACCEPTED_ANSWERS_DATE_DESCRIPTION": "Validate the date provided by the user against a reference date.",
      "ACCEPTED_ANSWERS_OPERATOR_LABEL": "Select an operator",
      "ACCEPTED_ANSWERS_QUESTION_OPTIONS_DESCRIPTION": "Select each possible answer.",
      "ACCEPTED_ANSWERS_SUMMARY": "Allowed responses",
      "ACCEPTED_ANSWERS_TEXT_DESCRIPTION": "Separate each allowed response with a line break.",
      "ACCEPTED_ANSWERS_TEXT_PLACEHOLDER": "Response 1  \nResponse 2  \nResponse 3  \nResponse 4",
      "ADD_DESCRIPTION": "Add a description",
      "ADD_QUESTION": "Add a question",
      "ADD_SECTION": "Add a section",
      "CONFIDENTIAL": "Confidential",
      "CONFIDENTIAL_INFORMATION_NOTICE": "Your response will only be visible to platform administrators.",
      "CONFIDENTIAL_QUESTION": "Confidential question",
      "CONFIDENTIAL_QUESTION_DESCRIPTION": "The answer will be visible only to administrators and managers with the rights.",
      "DATE_OPERATOR": {
        "EQ": "is",
        "GT": "is greater than",
        "GTE": "is greater than or equal to",
        "LT": "is less than",
        "LTE": "is less than or equal to",
        "NOT_EQ": "is not"
      },
      "DEFAULT_FIELD_INFO": "By default",
      "DESCRIPTION_LABEL": "Description",
      "DESCRIPTION_PLACEHOLDER": "Example: This question will allow us to get to know you better.",
      "DROPDOWN_QUESTION": "Dropdown list",
      "DROPDOWN_QUESTION_DESCRIPTION": "The options will be displayed in a dropdown list",
      "MAXLENGTH": "Limit the number of characters",
      "MAXLENGTH_DESCRIPTION": "Enter the maximum number of allowed characters",
      "MAXLENGTH_LABEL": "Number of characters",
      "MAXLENGTH_PLACEHOLDER": "Unlimited",
      "MAXLENGTH_SUMMARY": "Maximum characters",
      "OPTIONS": {
        "ADD_OPTION": "Add an option",
        "ADD_OTHER": "Add \"Other\"",
        "OR": "or",
        "OTHER": "Other"
      },
      "OPTION_LABEL": "Option {index}",
      "PLACEHOLDER": "Your answer",
      "QUESTION_LINKS": {
        "DESCRIPTION": "Show if the answer to ...",
        "OPERATOR": {
          "BLANK": "is empty",
          "CONTAINS": "contains",
          "EQ": "is",
          "GT": "is greater than",
          "GTE": "is greater than or equal to",
          "LT": "is less than",
          "LTE": "is less than or equal to",
          "NOT_CONTAINS": "does not contain",
          "NOT_EQ": "is not",
          "PRESENT": "is not empty"
        },
        "OPERATOR_LABEL": "Operator",
        "OPTIONS_LABEL": "Options",
        "QUESTION_LABEL": "Question",
        "TITLE": "Displaying the question"
      },
      "QUESTION_LINKS_SUMMARY": "Display condition",
      "REQUIRED": "Required",
      "REQUIRED_QUESTION": "Required question",
      "SUBMIT_FORM": "Submit the form",
      "SURVEY_DESCRIPTION_1": "The questionnaire corresponds to the questions you want to ask your users.",
      "SURVEY_DESCRIPTION_2": "Set up the questionnaire according to your consultation.",
      "SURVEY_TITLE": "Questionnaire",
      "TITLE_LABEL": "Question",
      "TITLE_PLACEHOLDER": "Example: What is your age?",
      "TYPES": {
        "ATTACHMENT": "Attachments",
        "CHECKBOX": "Multiple responses",
        "DATE": "Date",
        "LOCATION": "Localisation",
        "MONEY": "Budget",
        "PHONE_NUMBER": "Phone number",
        "PICTURE": "Cover image",
        "RADIO": "Unique response",
        "SECTION": "Section",
        "TEXT": "Short answer",
        "TEXTAREA": "Paragraph",
        "TITLE": "Field type"
      },
      "TYPE_SELECT_WARNING": {
        "DESCRIPTION_1": "You have already collected responses for this question.",
        "DESCRIPTION_2": "If you modify it, the associated responses will be permanently deleted.",
        "DESCRIPTION_3": "Do you need this data? Export your responses before deleting the question and/or option.",
        "TITLE": "Are you sure?"
      }
    },
    "GENERAL_INFO": "General information",
    "IMAGE": "Image",
    "LOCALISATION_LABEL": "Location or address",
    "LOCALISATION_MARKER_PLACED": "Marker placed",
    "LOCALISATION_MODAL_NEGATIVE_BUTTON": "Clear",
    "LOCALISATION_MODAL_NOTICE_TEXT": "Click on the map to position the marker.",
    "LOCALISATION_MODAL_POSITIVE_BUTTON": "Confirm",
    "LOCALISATION_MODAL_TITLE": "Add a location",
    "LOCALISATION_NO_RESULTS": "Please type to get suggestions",
    "LOCALISATION_PLACEHOLDER": "Add a location",
    "LOCALISATION_SEE_MAP": "View map",
    "MODERATABLE": {
      "LABEL": "Pre-publication moderation",
      "TOOLTIP": "All contributions must be validated by an administrator to be published and visible to other users."
    },
    "NEW": {
      "ANOMALIES": {
        "DESCRIPTION_PLACEHOLDER": "Formulate a description that specifies the anomaly encountered and its nature. Contextualize it in order to facilitate its treatment.",
        "MODAL_DESCRIPTION": "{spaceName} will answer you as soon as possible.",
        "MODAL_TITLE": "Congratulations, the anomaly is sent!",
        "SIDEBAR_ACTION": "Send",
        "SIDEBAR_DESCRIPTION": "The organisation is here to listen and will respond as soon as possible.",
        "TITLE": "Report an anomaly",
        "TITLE_PLACEHOLDER": "I would like to signal…"
      },
      "ARTICLES": {
        "DESCRIPTION_PLACEHOLDER": "Present a topical subject or highlight an initiative in order to provide regular information on new measures and disseminate pedagogical information.",
        "MODAL_DESCRIPTION": "It is now visible to other users of this space. {isPrivateSpace, select, true {} other {Share it on social networks to give it even more visibility.}}",
        "MODAL_TITLE": "Congratulations, the article is published!",
        "PROBLEMATIC_PLACEHOLDER": "Describe your article in one sentence to make people want to read it",
        "TITLE": "Create an article",
        "TITLE_PLACEHOLDER": "Write a headline that appeals to users."
      },
      "COLLABORATIVE_DECISIONS": {
        "DESCRIPTION_PLACEHOLDER": "Provide details on the background to this collaborative decisions. Explain the modalities of participation so that users can meaningfully participate in the search for solutions.",
        "MODAL_DESCRIPTION": "It is now visible to other users. Pin it to your homepage by featuring it for even more visibility.",
        "MODAL_TITLE": "Congratulations, the collaborative decisions is published!",
        "PROBLEMATIC_PLACEHOLDER": "Give users a reason to participate in one sentence.",
        "SIDEBAR_ACTION": "Publish",
        "TITLE": "Create a collaborative decisions",
        "TITLE_PLACEHOLDER": "Write a headline that appeals to users."
      },
      "DEMANDS": {
        "DESCRIPTION_PLACEHOLDER": "Clarify the context of the message by providing any element that allows for a better understanding of your topic.",
        "MODAL_CTA": "View my messages",
        "MODAL_DESCRIPTION": "The recipient will receive a notification as soon as possible. You can at any time find this message in the \"My messages & issues\" menu of your profile.",
        "MODAL_TITLE": "Congratulations, the message is sent!",
        "SIDEBAR_ACTION": "Send",
        "SIDEBAR_DESCRIPTION": "This message is private. Only the user and the admins can see it.",
        "TITLE": "Send a message",
        "TITLE_PLACEHOLDER": "I would like information about"
      },
      "EVENTS": {
        "CONFIGURATION": {
          "DESCRIPTION": "This section allows you to explain how users can attend your event: date and location (address and / or link to an online meeting).",
          "TITLE": "How to attend"
        },
        "DESCRIPTION_PLACEHOLDER": "Introduce the context of the event and inform users about the conditions to get there.",
        "MODAL_DESCRIPTION": "It is now visible to other users. Share it on social networks to give it even more visibility.",
        "MODAL_TITLE": "Congratulations, the event is published!",
        "PROBLEMATIC_PLACEHOLDER": "Describe your event in one sentence to make people want to read it.",
        "SIDEBAR_ACTION": "Publish",
        "TITLE_PLACEHOLDER": "Write a headline that appeals to users."
      },
      "FOLDERS": {
        "DESCRIPTION_PLACEHOLDER": "Provide details on the context of this folder. Explain the forms of participation so that users can become meaningfully involved in the search for solutions.",
        "MODAL_DESCRIPTION": "It is now visible to other users. Pin it to your homepage by featuring it for even more visibility.",
        "MODAL_TITLE": "Congratulations, the folder has been published!",
        "PROBLEMATIC_PLACEHOLDER": "Add an inspiring sentence about your file.",
        "SIDEBAR_ACTION": "Publish",
        "TITLE_PLACEHOLDER": "Write a headline that appeals to users."
      },
      "IDEAS": {
        "DESCRIPTION_PLACEHOLDER": "Explain your contribution and how it works.",
        "MODAL_CTA": "View my contributions",
        "MODAL_DESCRIPTION": "Find all your contributions in your profile.",
        "MODAL_DESCRIPTION_GUEST": "To track its progress and receive updates, create an account. Without registration, you will no longer be able to see its impact or be notified of votes and comments.",
        "MODAL_TITLE": "Thank you for your participation",
        "REDIRECT": "This link does not seem to work. Find the consultation in the list to be able to make a contribution.",
        "TITLE": "Fill out the form",
        "TITLE_PLACEHOLDER": "We could…",
        "WITHOUT_MODERATION": {
          "SIDEBAR_ACTION": "Publish",
          "SIDEBAR_DESCRIPTION": "Once published, other users will be able to enhance your contribution by making suggestions."
        },
        "WITH_MODERATION": {
          "SIDEBAR_ACTION": "Submit",
          "SIDEBAR_DESCRIPTION": "The contribution will be published once validated by the services."
        }
      },
      "IDEAS_REQUESTS": {
        "DESCRIPTION_PLACEHOLDER": "Provide details about the context of this call for contributions. Explain the terms of participation so that users can participate in the search for solutions in a relevant manner.",
        "MODAL_DESCRIPTION": "It is now visible to other users. Pin it to your homepage by featuring it for even more visibility.",
        "MODAL_TITLE": "Congratulations, the call for contributions is published!",
        "PROBLEMATIC_PLACEHOLDER": "Give users a reason to participate in one sentence.",
        "SIDEBAR_ACTION": "Publish",
        "TITLE_PLACEHOLDER": "Write a headline that appeals to users."
      },
      "PARTICIPATORY_BUDGETS": {
        "DESCRIPTION_PLACEHOLDER": "Provide details on the background to this participatory budget. Explain the modalities of participation so that users can meaningfully participate in the search for solutions.",
        "MODAL_DESCRIPTION": "It is now visible to other users. Pin it to your homepage by featuring it for even more visibility.",
        "MODAL_TITLE": "Congratulations, the participatory budget is published!",
        "PROBLEMATIC_PLACEHOLDER": "Give users a reason to participate in one sentence.",
        "SIDEBAR_ACTION": "Publish",
        "TITLE_PLACEHOLDER": "Write a headline that appeals to users."
      },
      "STUDIES": {
        "DESCRIPTION": "The survey corresponds to the form created outside the platform on Typeform, Google Form, Survey Monkey, Tally or any other platform that allows creating forms.",
        "DESCRIPTION_PLACEHOLDER": "Provide details about the context of this consultation as well as its participation modalities.",
        "FORM_DESCRIPTION": "Add the links to your survey to share it on your platform.",
        "MODAL_DESCRIPTION": "It is now visible to other users. Share it on social networks to give it even more visibility.",
        "MODAL_TITLE": "Congratulations, the study is published!",
        "PROBLEMATIC_PLACEHOLDER": "Give users a reason to participate in one sentence.",
        "SIDEBAR_ACTION": "Publish",
        "STUDY_ID_PLACEHOLDER": "Example: https://fluicity.typeform.com/to/A1b2C3d4",
        "STUDY_RESULT_PLACEHOLDER": "Example: https://fluicity.typeform.com/report/A1b2C3d4/E5f6G7h8",
        "STUDY_RESULT_TITLE": "Report URL",
        "STUDY_TITLE": "Form URL",
        "TITLE_PLACEHOLDER": "Write a headline that appeals to users."
      },
      "TITLE": {
        "ANOMALY": "Create an issue",
        "COMMUNICATION": "Create news",
        "CONSULTATION": "Create a consultation",
        "DEMAND": "Create a message",
        "FOLDER": "Create a folder",
        "IDEA": "Create a contribution"
      }
    },
    "POST_PUBLISHED": "This content is now published.",
    "POST_PUBLISHED_AT": "Published on {date} at {time}",
    "POST_SAVED": "This content is now saved.",
    "POST_SCHEDULED": "This content is scheduled for {date} at {time}.",
    "PROBLEMATIC": "Catch phrase",
    "PUBLICATION_CANCELLED": "The publication has indeed been cancelled.",
    "SIMILAR_PROPOSALS": "Other users seem to have shared similar contributions:",
    "START_AT": "Start date and time",
    "STEPS": {
      "CONFIGURATION": "Phase configuration",
      "DESCRIPTION": "This section allows you to communicate to users the key dates of the consultation.",
      "DESCRIPTION_TABS": "Step multilingual description tabs",
      "END_AT_HELPER_TEXT": "Optional for continuous steps",
      "IMPLEMENTATION": {
        "ADMIN_ONLY_PLACEHOLDER": "Remember to add the \"Results Link\" and check the configuration to enable the option.",
        "ADMIN_ONLY_TEXT": "Display the consultation results",
        "SURVEYS": {
          "ADMIN_ONLY_PLACEHOLDER": "The full report contains raw data for each question. This is an important element of transparency towards the users.",
          "ADMIN_ONLY_TEXT": "Display the consultation results"
        }
      },
      "PLACEHOLDER": "Explain how this step works.",
      "SUBMISSION": {
        "ADMIN_ONLY_PLACEHOLDER": "All users can publish contributions in the consultation. If the option is disabled, only administrators will be able to create new contributions.",
        "ADMIN_ONLY_TEXT": "Submission open to users"
      },
      "TITLE": "Schedule configuration"
    },
    "TITLE": "Title",
    "UNDERSTOOD": "Understood!",
    "VIDEO": "Video",
    "VIDEO_HELPER": "You can only share a Youtube or Vimeo link.",
    "VIDEO_LABEL": "Link to a video",
    "VIDEO_PLACEHOLDER": "Example: http://www.youtube.com/watch?=id or http://vimeo.com/id",
    "VOTING_OPTIONS": {
      "BUDGET_RULE": {
        "LABEL": "Restrict votes (for) to the budget of {count} previously defined",
        "TITLE": "Budget constraint"
      },
      "MIN_MAX": {
        "MAX_LABEL": "Maximum number of votes",
        "MIN_LABEL": "Minimum number of votes",
        "TITLE": "Number of allocated supports"
      },
      "TYPE": {
        "BUDGET": {
          "DESCRIPTION": "Users will be able to support contributions until the total envelope is exhausted. Contributions must be budgeted.",
          "NAME": "By envelope"
        },
        "DOUBLE": {
          "DESCRIPTION": "Users will be able to support contributions in a positive or negative way. It is often used in the case of calls for contributions or reactions.",
          "NAME": "For or Against"
        },
        "SINGLE": {
          "DESCRIPTION": "Users will be able to support contributions in a positive way only. This module is often used if your consultation includes a voting phase.",
          "NAME": "For"
        },
        "SUBTITLE_1": "The voting methods allow users to support the contributions made to your consultation.",
        "SUBTITLE_2": "Set the terms according to your project",
        "TITLE": "Voting Options"
      },
      "UNLIMITED": "Unlimited"
    }
  },
  "POST_STEPS_TYPES": {
    "DEFAULT": {
      "ANALYSIS": "Analysis",
      "CONTRIBUTION": "Contribution",
      "IMPLEMENTATION": "Results",
      "SUBMISSION": "Submission",
      "VOTE": "Vote"
    },
    "STUDY": {
      "IMPLEMENTATION": "Results",
      "SUBMISSION": "Answer"
    }
  },
  "PREVIOUS": "Previous",
  "PROFILE": {
    "ADDRESS": "Municipality",
    "BIRTHDATE": "Birthdate",
    "CROSS_SPACES_WARNING": "The information below concerns all the spaces you have joined.",
    "FIRST_NAME": "First name",
    "LAST_NAME": "Last name",
    "NAME_IS_PRIVATE": "Other users will see you as: {displayName}",
    "NATIONAL_ID": "National identification number",
    "PRIVATE_INFORMATION_NOTICE": "This information will be used only for statistical purposes related to participation.",
    "PROFILE_UPDATED": "Profile updated.",
    "SEX": "Sex",
    "SEX_FEMALE": "Female",
    "SEX_HELPER": "As indicated on your national identity card. Once aggregated, this data is compared to statistics provided by national institutes or by the organization itself.",
    "SEX_MALE": "Male",
    "SEX_UNSPECIFIED": "Non specified",
    "SOCIOPROFESSIONAL_CATEGORY": "Socioprofessional category",
    "TITLE": "My account"
  },
  "PUBLISHING_POST_DIALOG": {
    "NO_QUESTIONS_WARNING": "Before you can publish this content, you must {link} to the form",
    "NO_QUESTIONS_WARNING_LINK_TEXT": "add questions",
    "PARENT_WARNING": "Before you can publish this content, you must publish {link}.",
    "PUBLISH": {
      "BUTTON": "Publish now",
      "CONTENT": "Do you really want to publish?",
      "NO": "No",
      "TOAST": "This content has been published.",
      "YES": "Yes, publish"
    },
    "SCHEDULE": {
      "BUTTON": "Schedule the publication",
      "CONTENT": "Do you really want to schedule?",
      "NO": "No",
      "TOAST": "This content has been scheduled.",
      "YES": "Yes, schedule"
    },
    "UNPUBLISH": {
      "BUTTON": "Unpublish",
      "CHILDREN_WARNING": "By unpublishing this content, everything it contains will also be unpublished ({childrenCount}).",
      "CONTENT": "Are you sure you want to unpublish?",
      "NO": "No",
      "TOAST": "This content has been unpublished.",
      "YES": "Yes, unpublish"
    },
    "UNSCHEDULE": {
      "BUTTON": "Cancel scheduling",
      "CONTENT": "Do you really want to cancel the scheduling?",
      "NO": "No",
      "TOAST": "The scheduling of this content has been canceled.",
      "YES": "Yes, cancel the scheduling"
    }
  },
  "QUESTIONS": {
    "RESULTS": {
      "ANSWERS_COUNT": "{count, plural, =0 {No answers} one {{count} answer} other {{count} answers}}"
    }
  },
  "SEARCH": {
    "BUTTON": "Search",
    "CATEGORIES_PLACEHOLDER": "Filter by topic",
    "EMPTY_SEARCH": {
      "NEW_SEARCH": "Start typing keywords in the search bar.",
      "NO_RESULTS": "Check that you have spelled everything correctly. You can also try shortening or rewording your search."
    },
    "INPUT_PLACEHOLDER": "Search",
    "RESULTS_COUNT": "{count, plural, =0 {No results} one {{count} result} other {{count} results}}",
    "TYPES_PLACEHOLDER": "Filter by content type"
  },
  "SECURED_STRATEGIES": {
    "BACK_TO_POST": "Back to the consultation",
    "BIRTHDATE": {
      "TITLE": "Birthdate"
    },
    "CSAM": {
      "TITLE": "CSAM Login"
    },
    "CTA": "Participate",
    "DESCRIPTION": "<b>This consultation is secure.</b> To access it, you must validate the data listed below and provide the missing information.<conditional> At any time, you can exercise your rights of access, rectification, and deletion of this data by contacting dpo@flui.city.</conditional>",
    "DIMENSIONS": {
      "ERROR": "Unfortunately, the information you have specified does not allow you to participate in the consultation. Correct your data or return to the consultation.",
      "TITLE": "Dimensions"
    },
    "INLINE_DESCRIPTION": "<b>This consultation is secure.</b> To access it, you must provide the necessary data. At any time, you can exercise your rights of access, rectification, and erasure of this data via your profile page if you have an account or by email at dpo@flui.city.",
    "NATIONAL_ID": {
      "ERROR": "You must enter a valid register number containing 11 digits.",
      "TITLE": "Belgian national id"
    },
    "PENDING_VERIFICATION_TOOLTIP": "Your participation will be taken into account only <b>after verification of your documents</b>.",
    "PREVENT_GO_IDENTITY": {
      "BACK": "Back (New ID card only)",
      "FORM": {
        "DESCRIPTION": "Please provide the front and back of your ID (JPEG, JPG, PNG, HEIC, WEBP or PDF format, maximum recommended size 2MB).<br></br><br></br>Only the following are accepted: <ul><li>French national ID</li><li>French passport</li><li>French driver license (new format, credit card format)</li></ul>",
        "GENERIC_ERROR": "An error occurred while uploading your documents. Please check your connection status or try again later. You can also try reducing the size of the document (maximum recommended size 2MB).",
        "SUCCESS_TOAST": "Your identity has been verified successfully."
      },
      "FRONT": "Front",
      "NO": "No",
      "TITLE": "Identity document",
      "YES": "Yes"
    },
    "PROOF_OF_RESIDENCY": {
      "ACCEPTED_DOCUMENTS": "Only the following are accepted: <ul><li>Recent electricity, gas, or water bill</li><li>Landline or mobile phone bill</li><li>Pay slip</li><li>Home insurance certificate (fire, tenant risks, or civil liability)</li><li>Voter card</li><li>Tax notice</li></ul>",
      "BUTTON_DISABLED_TOOLTIP": "You must first validate your ID document to send your proof of address.",
      "DESCRIPTION": "Please provide proof of address (JPEG, JPG, PNG, HEIC, WEBP, or PDF format, recommended maximum size 2MB).",
      "DOCUMENT_CONFIRMATION": "After verification by our teams, an email will be sent to you to confirm your participation.",
      "TITLE": "Proof of address"
    },
    "QUESTIONS": {
      "INCORRECT_VALUE": "This value is incorrect."
    },
    "SIGNUP_INVITATION": "If you want to <b>receive a confirmation email</b> of your participation and save your documents, please create an account.",
    "SUCCESS": "You can now participate in the consultation.",
    "TOOLTIP": "This consultation is secure and requires certain information to participate.",
    "VALIDATED_INLINE_DESCRIPTION": "We validated your identity as <b>{fullName}</b>.",
    "VERIFIED_EMAIL": {
      "TITLE": "Account verification"
    }
  },
  "SECURITY": {
    "DISPLAY_SECURED_STRATEGY_QUESTIONS": "Show security questions",
    "FORM_BUILDER": {
      "DESCRIPTION": "Security questions are access control mechanisms.<br></br> They allow verifying that participants meet certain conditions before contributing, voting, commenting, or responding to a survey (for example: access code, national ID, resident of a territory, etc.).",
      "TITLE": "Security questions"
    },
    "OPTION_1": {
      "DESCRIPTION": "No registration is required to participate",
      "TITLE": "Everyone"
    },
    "OPTION_2": {
      "DESCRIPTION": "Users must register to participate",
      "TITLE": "Registered"
    },
    "OPTION_3": {
      "DESCRIPTION": "Users must verify their account to participate.",
      "TITLE": "Verified participants"
    },
    "OPTION_4": {
      "DESCRIPTION": "The repository is closed to users.",
      "TITLE": "Administrators"
    },
    "WHO_CAN_COMMENT": "Who can comment?",
    "WHO_CAN_RESPOND_SURVEY": "Who can respond to the survey?",
    "WHO_CAN_SUBMIT_CONTRIBUTION": "Who can submit a contribution?",
    "WHO_CAN_VOTE": "Who can vote?"
  },
  "SETTINGS": {
    "ACCOUNT": {
      "CONNECTION_SETTINGS": "Login settings",
      "DATA_SHARED_WITH_SPACE": "My data",
      "LANGUAGE": "Language",
      "PASSWORD": "Password (12 characters minimum)",
      "VERIFIED": "Verified",
      "VERIFIED_EMAIL": "Email verified"
    },
    "COOKIES": {
      "DESCRIPTION": "These “functional” cookies allow the activation of specific capabilities on Fluicity Engage in order to improve your user experience.",
      "FACEBOOK": {
        "DESCRIPTION": "Allows you to login to your participation space using your Facebook credentials.",
        "TITLE": "Facebook Connect"
      },
      "GOOGLE": {
        "DESCRIPTION": "Allows you to login to your participation space using your Google credentials.",
        "TITLE": "Google Sign-in"
      },
      "TITLE": "My cookies related settings",
      "VIMEO": {
        "DESCRIPTION": "Allows you to view Vimeo videos embedded in the participation space.",
        "TITLE": "Vimeo"
      },
      "YOUTUBE": {
        "DESCRIPTION": "Allows you to view Youtube videos embedded in the participation space.",
        "TITLE": "Youtube"
      }
    },
    "DESTROY_ACCOUNT": {
      "CONFIRM": "Yes, delete my account",
      "CTA": "Delete my account",
      "TITLE": "Do you really want to delete your Fluicity Engage account?"
    },
    "EMAIL_SUBSCRIPTION": {
      "UNSUBSCRIBE": {
        "SUCCESS_DESCRIPTION": "To subscribe again, or unsubscribe from one or more types of notifications, use the settings below. You can access these parameters whenever you want from the settings of your account.",
        "SUCCESS_TITLE": "You have successfully unsubscribed from this kind of notifications."
      }
    },
    "JOIN_SPACE": "Join {spaceName}",
    "LANGUAGE": {
      "LABEL": "Language"
    },
    "LEAVE_SPACE": {
      "CONFIRM": "Yes, leave space",
      "CTA": "Leave {spaceName}",
      "DESCRIPTION": "By leaving this space, you will no longer receive notifications related to consultations or news and will no longer be able to make new contributions, comment, vote, etc.",
      "TITLE": "Do you really want to leave {spaceName}?"
    },
    "NO_SPACES": "You are not following any spaces.",
    "PASSWORD": {
      "CONFIRMATION": "Confirm password",
      "CREATE": "Create",
      "CREATE_INPUT": "Create a password",
      "CREATE_MESSAGE": "You have not set a password yet",
      "CURRENT": "Current password",
      "DIALOG": {
        "CREATE_TITLE": "Create a password",
        "SUBTITLE_2": "Please enter your current password and your new password:",
        "TITLE": "Change my password",
        "VALIDATE": "Confirm"
      },
      "ERROR_LOGIN": "Login error.",
      "FORGOT_PASSWORD": "Forgotten your password?",
      "NEW": "New password",
      "PLACEHOLDER": "Password",
      "SHORT_PASSWORD": "password length cannot be less than {length}",
      "SUCCESS": "Your password has been saved.",
      "UPDATE": "Change",
      "WRONG_PASSWORD": "The password must be at least 8 characters long."
    },
    "PERSONAL_DATA": {
      "REQUEST_PERSONAL_DATA": {
        "BUTTON": "Request access to my personal data",
        "EMAIL_BODY": "Hello,\n\nIn accordance with the Personal data privacy policy of the Fluicity Engage solution, I’d like to receive an export of all the personal data attached to my account ({userEmail}) hosted on the platform.\n\nBest regards,\n\n{userName}",
        "EMAIL_SUBJECT": "Request for data portability"
      },
      "TITLE": "Privacy and personal data"
    },
    "REQUIRED_DIMENSION_INFO": "Certain information is required for participation in this space. To exercise your right to erasure, simply exit the space.",
    "SPACE_SELECTION": "Space selection",
    "TABS": {
      "INFO": "My details",
      "MY_SPACE": "My space",
      "NOTIFICATIONS": "My notifications",
      "SETTINGS": "My settings"
    }
  },
  "SIGN_IN": "Join",
  "SIGN_OUT": "Sign out",
  "SIGN_UP": {
    "EMAIL": "E-mail",
    "LOCATION_LABEL": "City of residency",
    "LOCATION_PLACEHOLDER": "Example: London",
    "PRIVACY": "Privacy Policy",
    "TERMS": "Terms of Use"
  },
  "SORT": {
    "COMMENTED": "The most commented",
    "LEAST_EXPENSIVE": "The least expensive",
    "POPULAR": "The most Popular",
    "RANDOM": "Random",
    "RECENT": "The most recent",
    "UPVOTED": "The most voted"
  },
  "SPACE": {
    "ABOUT": {
      "STATS": {
        "CONSULTATIONS_COUNT": "{count, plural, =0 {consultation launched} one {consultation launched} other {consultations launched}}",
        "IDEAS_DONE_COUNT": "{count, plural, =0 {accomplished contribution} one {accomplished contribution} other {accomplished contributions}}",
        "PARTICIPATIONS_COUNT": "{count, plural, =0 {participation} one {participation} other {participations}}",
        "SUBSCRIBED_CITIZENS": "{count, plural, =0 {registered user} one {registered user} other {registered users}}"
      },
      "TITLE": "General"
    },
    "CONSULTATIONS": {
      "EMPTY_STATE": "You will find here the folders, calls for contributions, participatory budgets, and studies published by the organization.",
      "TITLE": "{count, plural, =0 {No Consultations} one {{count} Consultation} other {{count} Consultations}}"
    },
    "CONTRIBUTIONS": {
      "MESSAGING": {
        "EMPTY_STATE": "Here you will find your messages and anomalies.",
        "TITLE": "My Messages & Anomalies"
      },
      "PROPOSALS": {
        "EMPTY_STATE": "You will find your contributions here.",
        "TITLE": "My contributions"
      }
    },
    "FORM": {
      "ADDRESS_LABEL": "Address",
      "ADDRESS_PLACEHOLDER": "Search for an address",
      "ADMINISTRATORS": "Administrators",
      "BRAND_LOGO_LABEL": "Space logo",
      "BRAND_LOGO_TOOLTIP": "The space logo will appear on the top-left part of the platform, in the navigation, and in the emails.",
      "COLOR_LABEL": "Color",
      "COLOR_PLACEHOLDER": "Color",
      "DECISION_MAKER_FIRST_NAME_LABEL": "First name of the sponsor",
      "DECISION_MAKER_FIRST_NAME_PLACEHOLDER": "Set the first name",
      "DECISION_MAKER_LAST_NAME_LABEL": "Last name of the sponsor",
      "DECISION_MAKER_LAST_NAME_PLACEHOLDER": "Set the last name",
      "DECISION_MAKER_PICTURE_LABEL": "Profile picture of the sponsor",
      "DECISION_MAKER_ROLE_LABEL": "Role of the sponsor",
      "DECISION_MAKER_ROLE_PLACEHOLDER": "Write the role of the sponsor in your organisation",
      "DESCRIPTION_HELPER": "The meta description tag allows search engines to have a preview of the content of the pages displayed during a search.",
      "DESCRIPTION_LABEL": "Meta description",
      "DESCRIPTION_PLACEHOLDER": "Provide a short and catchy text to greet and engage",
      "EMAIL_LABEL": "E-mail",
      "EMAIL_PLACEHOLDER": "email@mywebsite.com",
      "FACEBOOK_URL_LABEL": "Facebook",
      "FACEBOOK_URL_PLACEHOLDER": "https://www.facebook.com/mypage",
      "FAVICON_LABEL": "Favicon",
      "FAVICON_TOOLTIP": "The favicon is the small icon in the browser’s tabs at the top of the screen.",
      "INSTAGRAM_URL_LABEL": "Instagram",
      "INSTAGRAM_URL_PLACEHOLDER": "https://www.instagram.com/mypage",
      "LEGAL_NOTICE": {
        "COMPANY_ADDRESS": "Address: 210 avenue Jean Jaurès, 69007 Lyon, France",
        "COMPANY_EMAIL": "Email: info@flui.city",
        "COMPANY_NAME": "Fluicity",
        "COMPANY_PHONE": "Phone: +33 4 72 51 77 55",
        "HOSTED_BY_AWS": "Hosted by: Amazon Web Services (AWS) in Paris, France",
        "HOSTING": "Accommodation",
        "HOSTING_AND_TECHNICAL_SOLUTION": "Hosting and technical solution",
        "HOST_ADDRESS": "Host's address: 38 avenue John F. Kennedy, L-1855 Luxembourg",
        "PLATFORM_HOSTED_BY": "The platform is hosted and powered by Fluicity Engage, a solution published by the company Fluicity.",
        "THIRD_PARTY_TRUST": "Fluicity Engage acts as a trusted third party for the collection and processing of data, in compliance with the GDPR."
      },
      "LINKEDIN_URL_LABEL": "LinkedIn",
      "LINKEDIN_URL_PLACEHOLDER": "https://www.linkedin.com/mypage",
      "LOCALES": "Languages",
      "LOCALES_HELPER": "Select the languages in which users can navigate on your platform.",
      "LOCALES_LABEL": "Available languages",
      "LOCALE_DEFAULT_HELPER": "Select the default language for your platform.",
      "LOCALE_DEFAULT_LABEL": "Default language",
      "LOGO_PICTURE_LABEL": "Profil picture of the administrators",
      "LOGO_PICTURE_TOOLTIP": "When they create a consultation, a contribution, a message or comment on the platform, administrators will be identified by this profile picture and the name of the space instead of their own picture and name.",
      "NAME_HELPER": "The name of the space will be displayed in many places: in the name of the pages, in the emails, instead of the name of the admins, etc.",
      "NAME_LABEL": "Space name",
      "NAME_PLACEHOLDER": "Set the space name",
      "PHONE_LABEL": "Phone",
      "PHONE_PLACEHOLDER": "0123456789",
      "PRIMARY_COLOR_LABEL": "Primary color",
      "PRIMARY_COLOR_PLACEHOLDER": "Primary color",
      "SECONDARY_COLOR_LABEL": "Secondary color",
      "SECONDARY_COLOR_PLACEHOLDER": "Secondary color",
      "SPACE_DECISION_MAKER": "Sponsor",
      "SPACE_DECISION_MAKER_TOOLTIP": "The sponsor is someone from your organisation who will engage and motivate users.",
      "SPACE_LEGAL_NOTICE": "Legal notice",
      "SPACE_LEGAL_NOTICE_LABEL": "Description",
      "SPACE_LEGAL_NOTICE_PLACEHOLDER": "This page appears at the bottom of your platform, below the footer, with information pre-filled by Fluicity Engage as the host and technical publisher of the solution.",
      "SPACE_LEGAL_NOTICE_TOOLTIP_1": "The legal notices inform users about the identity of the site manager, the host, and the conditions for editing the platform.",
      "SPACE_LEGAL_NOTICE_TOOLTIP_2": "They are mandatory for any institutional or public site, and they enhance the transparency of your approach.",
      "SPACE_PRIVACY_POLICY": "Privacy Policy",
      "SPACE_PRIVACY_POLICY_LABEL": "Description",
      "SPACE_PRIVACY_POLICY_PLACEHOLDER": "This page appears at the bottom of your platform, beneath the footer, with Fluicity Engage information.",
      "SPACE_PRIVACY_POLICY_TOOLTIP_1": "The privacy policy informs participants about the processing of their personal data. You can add specific details related to your organization here (e.g., specific retention period, DPO contact, internal use of data, etc.).",
      "SPACE_PRIVACY_POLICY_TOOLTIP_2": "This text supplements the <link>privacy policy of Fluicity Engage</link>, the technical manager of the platform, and the guarantor of GDPR compliance. Adding your own text remains optional depending on your use of the platform.",
      "SPACE_TERMS_OF_USE": "Terms of Use",
      "SPACE_TERMS_OF_USE_LABEL": "Description",
      "SPACE_TERMS_OF_USE_PLACEHOLDER": "Add here the content of your personalized Terms of Use",
      "SPACE_TERMS_OF_USE_TOOLTIP_1": "The terms of use define the rules for proper use of your space, the rights and responsibilities of users, as well as your commitments as the organizer of the process. (e.g., moderation rules, participation rights, etc.).",
      "SPACE_TERMS_OF_USE_TOOLTIP_2": "This text supplements the <link>Terms of Use of Fluicity Engage</link>, as a trusted third party and platform publisher. Adding your own text remains optional depending on your use of the platform.",
      "TOPICS": "Topics",
      "TOPICS_DESCRIPTION": "Themes allow you to categorize your content to help users find content by their area of interest.",
      "TWITTER_URL_LABEL": "Twitter",
      "TWITTER_URL_PLACEHOLDER": "https://twitter.com/mypage",
      "UPDATED_SUCCESSFULLY": "Space updated successfully.",
      "USERS_NOTIFICATIONS_SETTINGS": {
        "EVENTABLE": {
          "LABEL": "Send a notification automatically when a consultation is launched and for all its participation phases."
        },
        "TITLE": "Notifications",
        "WEEKLY": {
          "LABEL": "Send a summary of the week's news to subscribers (new articles, new events and reminders to participate in a consultation)."
        }
      },
      "WEBSITE_URL_LABEL": "Website URL",
      "WEBSITE_URL_PLACEHOLDER": "https://www.mywebsite.com",
      "YOUR_SPACE": "Your space"
    },
    "HOME": {
      "AFFILIATES": {
        "AFFILIATED": "Linked spaces",
        "SEE_MORE": "See more ({count})"
      },
      "FOOTER": {
        "TITLE": "Stay connected"
      },
      "SEE": "See",
      "SPACE_INFO": {
        "CITIZENS_COUNT": "{count, plural, =0 {No users} one {{count} user} other {{count} users}}",
        "IDEAS_COUNT": "{count, plural, =0 {No participation} one {{count} participation} other {{count} participations}}"
      },
      "SPONSOR": "This space is associated with"
    },
    "NEWS": {
      "EMPTY_STATE": "Here you will find the articles and events published by the organization.",
      "TITLE": "{count, plural, =0 {No News} one {{count} News} other {{count} News}}"
    },
    "PRIVACY_POLICY": {
      "ACCESS_FLUICITY_PRIVACY": "Read the Privacy Policy of Fluicity Engage"
    },
    "SETTINGS": {
      "ACCESS": {
        "TAB_DATA_COLLECTION": "Registration form",
        "TAB_INVITATIONS": "Invitations"
      },
      "COMMUNICATION": {
        "TAB_NOTIFICATIONS": "Notifications"
      },
      "GENERAL": {
        "TAB_APPEARANCE": "Appearance",
        "TAB_LANGUAGES": "Languages",
        "TAB_TOPICS": "Topics"
      },
      "LEGAL": {
        "TAB_LEGAL_NOTICE": "Legal Notice",
        "TAB_PRIVACY_POLICY": "Privacy Policy",
        "TAB_TERMS_OF_USE": "Terms of Use"
      },
      "PAGES": {
        "TAB_ABOUT": "About",
        "TAB_FOOTER": "Footer",
        "TAB_HOME": "Home",
        "TAB_NAVIGATION": "Navigation bar"
      }
    },
    "TERMS_OF_USE": {
      "ACCESS_FLUICITY_TERMS": "Read the Terms of Use of Fluicity Engage"
    }
  },
  "SPACE_DATA_COLLECTION": {
    "GENERAL_INFO": "General Information",
    "PROF_CATEGORY_ID": {
      "LABEL": "Socio-Professional Category"
    },
    "SECTION": {
      "HEADER": "Registration Form",
      "SUBTITLE1": "The registration form is a tool used to collect user data.",
      "SUBTITLE2": "Configure the collection fields according to your needs while respecting GDPR."
    }
  },
  "STATS": {
    "AGE": {
      "BETWEEN_15_AND_29": "15-29",
      "BETWEEN_30_AND_44": "30-44",
      "BETWEEN_45_AND_59": "45-59",
      "BETWEEN_60_AND_74": "60-74",
      "GT_75": ">75",
      "LT_15": "<15",
      "TITLE": "Age"
    },
    "AI": {
      "ACTIONS": "User aspirations:",
      "ACTIONS_TOOLTIP": "This summary of user aspirations is generated by AI. Its aim is to help you interpret the original contributions submitted by participants. It is based on the aggregated contributions below.",
      "ADD_CLUSTER": "Add a theme",
      "ADD_SUB_CLUSTER": "Add a sub-theme",
      "CLUSTER": {
        "SUMMARY": "Theme description",
        "SUMMARY_PLACEHOLDER": "The description of the theme",
        "TITLE": "Theme name",
        "TITLE_PLACEHOLDER": "The thematic group name will be used by the AI to group contributions."
      },
      "DELETE": "Delete",
      "DESCRIPTION": "Description:",
      "EDIT": "Edit",
      "EDIT_CLUSTER": "Edit the theme",
      "EDIT_SUB_CLUSTER": "Edit the sub-theme",
      "EXPLAIN_AI": "We use artificial intelligence to carefully examine the contributions of this consultation. Our goal is to group them into different categories based on their similarity, in order to provide you with a better understanding of trends, main aspirations, and emerging contributions. Through this approach, you will be able to better grasp the emerging contributions and the opinions that arise within this consultation.",
      "GENERATE": "Start the analysis",
      "IDEAS": "Original contributions:",
      "IN_FAVOR": "In favor",
      "MOVE_IDEA": "Move",
      "MOVE_IDEA_TITLE": "Change the theme or the sub-theme",
      "OPPOSED": "Against",
      "SUB_CLUSTER": {
        "SUMMARY": "Sub-theme description",
        "SUMMARY_PLACEHOLDER": "The description of the sub-theme",
        "TITLE": "Sub-theme name",
        "TITLE_PLACEHOLDER": "The name of the thematic subgroup will be used by the AI to group contributions."
      },
      "TOAST": "The AI analysis is being performed. This may take a few minutes."
    },
    "CITIES": {
      "TITLE": "Place of residence"
    },
    "CLUSTERS": "Themes",
    "CLUSTERS_TOOLTIP": "The various user aspirations are grouped together by the AI into one or more themes",
    "CLUSTER_OTHER": "Other",
    "COUNTER_WITH_TREND": {
      "TOOLTIP": "Over the last 7 days"
    },
    "COUNT_PROPOSALS": "{count} {count, plural, 0 {contribution} one {contribution} other {contributions}}",
    "DAY": "Day",
    "DELIVERABILITY": "Deliverability",
    "IDEAS_STATUSES": {
      "TITLE": "Status of contributions"
    },
    "KPIS": {
      "TOTAL_COMMENTS": "{count, plural, 0 {Comments} one {Comment} other {Comments}}",
      "TOTAL_FORM_RESPONSES": "{count, plural, 0 {Response} one {Response} other {Responses}}",
      "TOTAL_PARTICIPANTS": "{count, plural, 0 {Participants} one {Participant} other {Participants}}",
      "TOTAL_VOTES_AGAINST": "{count, plural, 0 {Votes against} one {Vote against} other {Votes against}}",
      "TOTAL_VOTES_FOR": "{count, plural, 0 {Votes for} one {Vote for} other {Votes for}}"
    },
    "MONTH": "Month",
    "NO_DATA": "There is no data available at this time.",
    "PARTICIPANTS": {
      "TITLE": "Number of participants",
      "TOTAL_PARTICIPANTS": "Participants",
      "TOTAL_TARGETED_USERS": "Registered users"
    },
    "PARTICIPANTS_PROGRESSION": "Evolution of the participants",
    "PARTICIPANTS_WHO_PERFORMED_AN_ACTION": {
      "TITLE": "Actions performed by participants",
      "TOTAL_COMMENTS": "Comments",
      "TOTAL_IDEAS": "Submitted a contribution",
      "TOTAL_NO_ACTIONS": "No actions",
      "TOTAL_STUDY_ANSWERS": "Responds to a study",
      "TOTAL_VOTES": "Votes"
    },
    "PARTICIPATION_PROGRESSION": "Evolution of participation",
    "PERFORMANCE": "Performance",
    "PROF_CATEGORIES": {
      "TITLE": "Socio-professional category"
    },
    "REFERRERS": "Referrers",
    "SECTIONS": {
      "ACTIVITY": "Activity",
      "ENGAGEMENT": "Engagement",
      "PARTICIPANTS_PROFILE": "Participants profile"
    },
    "SEX": {
      "TITLE": "Sex",
      "TOTAL_": "Non specified",
      "TOTAL_FEMALE": "Female",
      "TOTAL_MALE": "Male",
      "TOTAL_UNSPECIFIED": "Non specified"
    },
    "SUBSCRIPTIONS": {
      "TITLE": "Registrations target",
      "TOTAL_TARGETED_USERS": "Target",
      "TOTAL_USERS": "Registered users"
    },
    "SUBSCRIPTION_PROGRESSION": {
      "TITLE": "Evolution of the registrations"
    },
    "TAB_AI": "AI Analysis (beta)",
    "TAB_ATTENDEES": "Attendees",
    "TAB_CONTENTS": "Content",
    "TAB_DETAILS": "Détails",
    "TAB_EMAILS": "Email with the author",
    "TAB_LIST": "List",
    "TAB_PARTICIPATION": "Participation",
    "TAB_PRIVATE_NOTES": "Internal notes",
    "TAB_PROPOSALS": "Contributions",
    "TAB_RESPONSES": "Responses",
    "TAB_RESULTS": "Results",
    "TAB_SETTINGS": "Settings",
    "TAB_STATS": "Statistics",
    "TAB_VOTES": "Votes",
    "TARGETED_POPULATION": "Demographics (official source)",
    "TOP_CONSULTATIONS": {
      "COL_TITLE": "Title",
      "COL_TOTAL": "Participants",
      "SUBTITLE": "Total contributions, comments, votes or studies responses",
      "TITLE": "Top consultations"
    },
    "TOP_VIEWED_POSTS": {
      "COL_TITLE": "Title",
      "COL_TOTAL": "Visitors",
      "COL_TYPE": "Type",
      "TITLE": "Most visited content"
    },
    "TOTAL_ANSWERS": "{answersCount} out of {totalCount} {totalCount, plural, 0 {respondent} one {respondent} other {respondents}}",
    "TOTAL_BOUNCED": "Bounced",
    "TOTAL_CLICKED": "Clicked",
    "TOTAL_COMMENTS": "Comments",
    "TOTAL_COMMUNICATIONS": "News",
    "TOTAL_CONSULTATIONS": "Consultations",
    "TOTAL_DELIVERED": "Delivered",
    "TOTAL_IDEAS": "Contributions",
    "TOTAL_OFFLINE_VOTES": "Offline votes",
    "TOTAL_ONLINE_VOTES": "Online votes",
    "TOTAL_OPENED": "Opened",
    "TOTAL_PARTICIPANTS": "Participants",
    "TOTAL_REJECTED": "Rejected",
    "TOTAL_RESPONDENTS": "Respondents",
    "TOTAL_SENT": "Sent",
    "TOTAL_STUDY_ANSWERS": "Responses to study",
    "TOTAL_USERS": "Registered users",
    "TOTAL_VOTERS": "Voters",
    "TOTAL_VOTES": "Votes",
    "UNIQUE_VISITS": "Unique visits",
    "USERS_WHO_ANSWERED": "{count} {count, plural, 0 {respondents} one {respondent} other {respondents}}",
    "USERS_WHO_PERFORMED_AN_ACTION": {
      "TITLE": "Actions performed by the users",
      "TOTAL_COMMENTS": "Comments",
      "TOTAL_IDEAS": "Submitted a contribution",
      "TOTAL_NO_ACTIONS": "No actions",
      "TOTAL_STUDY_ANSWERS": "Responds to a study",
      "TOTAL_VOTES": "Votes"
    },
    "WEEK": "Week",
    "WORD_CLOUD": "Word cloud"
  },
  "TEXT_FIELD": {
    "LENGTH": "{length}/{maxLength}",
    "LENGTH_ERROR": "{length}/{maxLength} - You have exceeded the character limit.",
    "LENGTH_ERROR_TEXT": "You have exceeded the character limit."
  },
  "TOGGLE_POSTS_VIEW": {
    "BUTTON_CAROUSEL": "Carousel",
    "BUTTON_GROUP": "Change the display mode",
    "BUTTON_LIST": "List",
    "BUTTON_MAP": "Map"
  },
  "TOKENS": "{count, plural, =0 {No Tokens} one {{count} Token} other {{count} Tokens}}",
  "TOPIC_FORM": {
    "ADD_TOPIC": "Add a topic",
    "DESTROY_WARNING_DIALOG": {
      "DESCRIPTION_1": "One or more contents on your platform are currently categorized under this theme.",
      "DESCRIPTION_2": "By modifying or deleting it, you will change the classification of these contents.",
      "TITLE": "Are you sure?"
    }
  },
  "TRANSLATION": {
    "REVERSE_TRANSLATE": "See original text",
    "SUCCESS": "The translation was completed successfully.",
    "TRANSLATE": "Translate",
    "TRANSLATING": "Translating…"
  },
  "UI_SECTION": {
    "FORM": {
      "ABOUT": {
        "SECTION_DESCRIPTION": "Blocks allow you to customize your page by highlighting information in text, image, and video format.",
        "SECTION_HEADER": "Blocks"
      },
      "HOME": {
        "SECTION_DESCRIPTION": "Blocks allow you to customize your page by highlighting information in text, image, video format, as well as featured content.",
        "SECTION_HEADER": "Blocks"
      },
      "ITEMS": {
        "ANOMALY_FORM": {
          "DESCRIPTION": "Reporting an issue privately",
          "TITLE": "Anomaly"
        },
        "CUSTOM_BLOCK": {
          "DESCRIPTION": "Text, image, and video",
          "TITLE": "Customized"
        },
        "DEMAND_FORM": {
          "DESCRIPTION": "Private contact via the platform",
          "TITLE": "Messaging"
        },
        "FEATURED_CONSULTATIONS": {
          "DESCRIPTION": "Spotlight, ongoing, and upcoming consultations",
          "TITLE": "Consultation"
        },
        "FEATURED_NEWS": {
          "DESCRIPTION": "Article and event",
          "TITLE": "News"
        },
        "FOLDERS": {
          "DESCRIPTION": "Folder and subfolder",
          "TITLE": "Folder"
        },
        "KPIS": {
          "DESCRIPTION": "Number of registrants, contributions, and consultations",
          "TITLE": "Some figures"
        },
        "LATEST_IDEAS": {
          "DESCRIPTION": "User participation",
          "TITLE": "Contribution"
        },
        "SPACE_INFO": {
          "TITLE": "Top banner"
        }
      },
      "LAYER_ADD_MEDIA": "Add media",
      "LAYER_ADD_PICTURE": "Picture",
      "LAYER_ADD_VIDEO": "Video",
      "LAYER_ALIGNMENT": {
        "CENTER": {
          "DESCRIPTION": "The texts are centered in relation to the media.",
          "LABEL": "Centered"
        },
        "LEFT": {
          "DESCRIPTION": "The texts are to the left of the media",
          "LABEL": "To the left"
        },
        "RIGHT": {
          "DESCRIPTION": "The texts are to the right of the media.",
          "LABEL": "To the right"
        },
        "TITLE": "Display"
      },
      "LAYER_COMMUNICATION_TYPE": {
        "ALL": "All the news",
        "ARTICLE": "Article",
        "EVENT": "Event",
        "LABEL": "Type",
        "PINNED": "Top stories"
      },
      "LAYER_CONSULTATION_TYPE": {
        "ALL": "All consultations",
        "ENDED": "Completed consultations",
        "LABEL": "Type",
        "ONGOING": "Ongoing consultations",
        "PINNED": "Top stories"
      },
      "LAYER_COUNTERS": {
        "CONSULTATIONS_COUNT": "Consultations launched",
        "CONTRIBUTIONS_COUNT": "Materialized contributions",
        "PARTICIPATIONS_COUNT": "Participations (contributions, survey responses, votes, and submitted comments)",
        "TITLE": "Display the number of:",
        "USERS_AND_PARTICIPATIONS_COUNT": "Users and participations",
        "USERS_COUNT": "Users"
      },
      "LAYER_CTA_LABEL": "Button label",
      "LAYER_CTA_LABEL_PLACEHOLDER": "What you want to display on the button",
      "LAYER_CTA_URL": "Button URL",
      "LAYER_CTA_URL_PLACEHOLDER": "Link to a page or document",
      "LAYER_DESCRIPTION_LABEL": "Description",
      "LAYER_DESCRIPTION_PLACEHOLDER": "Set the text of the bloc. Make it short and efficient.“",
      "LAYER_FILTERING_TYPE": {
        "ALL": "All folders",
        "CHILDREN": "Contents of a folder",
        "CUSTOM": "Custom",
        "SELECT_FOLDER": "Select a folder",
        "SELECT_FOLDERS": "Select folders",
        "TYPE_LABEL": "Filter type"
      },
      "LAYER_PICTURE_LABEL": "Picture",
      "LAYER_TITLE_LABEL": "Title",
      "LAYER_TITLE_PLACEHOLDER": "Set the title of the bloc",
      "SELECTION_DIALOG": {
        "TITLE": "Create a block"
      }
    }
  },
  "USERS": {
    "ACTIONS_MENU": {
      "CONTACT_USER": "Contact user",
      "INVITE": "Invite",
      "UNREGISTER": "Unregister",
      "UPDATE_ROLE": "Update role"
    },
    "EXPORT": "User data export",
    "EXPORT_SUCCESS_TOAST": "The export is in progress. You will receive an email with a link to download it.",
    "INVITATIONS": {
      "CREATE_FORM": {
        "EMAILS_LABEL": "List of coma-separated emails",
        "EMAILS_PLACEHOLDER": "Example: user1@organisation.com, user2@association.org",
        "MESSAGE_LABEL": "Invitation message",
        "MESSAGE_PLACEHOLDER": "Enter a short yet inspiring message that will make the users want to join your space and contribute.",
        "SUCCESS_TOAST": "Users have been successfully invited.",
        "TITLE": "Invite users",
        "WARNING": "Make sure that you have gathered the consent of the users before sending them an invitation."
      },
      "DELETE_FORM": {
        "CONTENT": "You are about to cancel the invitation sent to <b>{email}</b>. Do you really want to proceed?",
        "DELETE": "Delete",
        "TITLE": "Delete invitation"
      }
    },
    "UNREGISTER": {
      "DESCRIPTION_1": "You are about to unregister user “<strong>{userName}</strong>” from your participation space.",
      "DESCRIPTION_2": "If the space is private, the user will no longer be able to access it. You will have to re-invite the user to cancel this action.",
      "DESCRIPTION_3": "If the space is public, the user will no longer be able to participate. He or she will have to register again to cancel this action.",
      "DESCRIPTION_4": "Do you want to proceed?",
      "TITLE": "Unregister user"
    }
  },
  "USER_AVATAR": "User’s Avatar",
  "USER_VOTES_INFO": {
    "MAX_VOTES_ERROR": "You have reached the maximum number of votes",
    "MAX_VOTES_WARNING": "{count, plural, =0 {You cannot support more contributions} one {You can support <strong># additional contributions</strong>.} other {You can support <strong># contributions</strong> additional. }}",
    "MIN_VOTES_WARNING": "{count, plural, =0 {You support enough contributions} one {more <strong># support</strong> to validate your participation.} other {more <strong># supports</strong> to validate your participation.} }",
    "VALID_PARTICIPATION": "Your participation has been validated."
  },
  "VIEW_ALL": "View All",
  "VIRUS_SCAN": {
    "CLEAN": "Virus scan succeeded",
    "INFECTED": "Infected file",
    "INFECTED_ATTACHMENTS_ERROR": "A document seems infected. Please delete it before saving.",
    "NO_SCAN": "Virus scan in progress…"
  },
  "VOTERS": {
    "DUPLICATES": {
      "CARD": {
        "BIRTHDATE": "Date of birth: {birthdate}",
        "DELETE_VOTE": "Delete the vote",
        "EMPTY": "Not provided",
        "IMPORTED_AT": "Imported on {date}",
        "KEEP_BOTH": "Keep both",
        "PARTICIPATED_AT": "Participation on {date}"
      },
      "DESCRIPTION": "Duplicate analysis takes into account the users' first and last names. To resolve the duplicate, choose the vote you want to delete from the two entries.",
      "FOUND_DUPLICATES": "You have <b>{count, plural, one {{count} identified duplicate voter} other {{count} identified duplicate voters}}</b>. Last updated <b>{timeAgo}</b>",
      "LOADING": "Verification in progress…",
      "NO_DUPLICATES": "No duplicate identified. Last updated <b>{timeAgo}</b>",
      "PLACEHOLDER": "You will find here the voters identified as duplicates.",
      "REFRESH": "Refresh",
      "START_CHECK": "Start the verification",
      "TITLE": "Manage duplicates"
    }
  },
  "WYSIWYG": {
    "LINK_PROMPT": {
      "ENTER_URL": "Enter the URL"
    },
    "PLACEHOLDER": "Start typing..."
  }
}